export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        classification: "Classification",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      // Almikia Epic EC2a (TASK-120): one address book, the eleven contact types.
      contact_types: {
        lead_buyer: "Buyer lead",
        lead_tenant: "Tenant lead",
        client: "Client",
        tenant: "Tenant",
        guarantor: "Guarantor",
        owner_seller: "Owner (seller)",
        owner_lessor: "Owner (lessor)",
        colega: "Colega",
        supplier: "Supplier",
        ally: "Ally",
        developer: "Developer",
      },
      affiliation_required: "Choose the colleague's affiliation",
      types_placeholder: "Choose the contact types",
      types_selected:
        "%{smart_count} type selected |||| %{smart_count} types selected",
      colega_kinds: {
        independiente: "Independent",
        inmobiliaria: "Real estate agency",
      },
      colega_affiliations: {
        ampi: "AMPI",
        otra: "Other",
        ninguna: "None",
      },
      agreement: {
        yes: "Yes",
        no: "No",
      },
      business_units: {
        corretaje: "Corretaje",
        bpo: "BPO",
      },
      supplier_category: {
        create_item: "Create category %{item}",
        create_label: "Create category",
        create_error: "The category could not be created",
      },
      name_review: {
        badge: "Review name",
        mark_reviewed: "Mark as reviewed",
      },
      fields: {
        first_name: "First name(s)",
        last_name: "Paternal surname",
        second_last_name: "Maternal surname",
        contact_types: "Contact type",
        lead_source_id: "Origin",
        referred_by_contact_id: "Referred by",
        origin_colega_contact_id: "Colega of origin",
        business_unit: "Business unit",
        business_project_id: "Project",
        colega_kind: "Colega kind",
        colega_affiliation: "Affiliation",
        colega_agreement_signed: "Signed agreement",
        colega_company_id: "Real estate agency",
        supplier_category_id: "Supplier category",
        guarantor_of_contact_id: "Tenant guaranteed",
        tags: "Tags",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        company: "Company",
        managed_by_me: "Managed by me",
        no_type: "No type",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        project_id: "Project",
        client_id: "Client",
        lead_type: "Lead type",
        external_broker: "External broker",
        external_broker_legacy: "External broker (previous text)",
        colega_id: "Colleague",
        source: "Source",
        source_legacy: "Source (previous text)",
        lead_source_id: "Source",
        score: "Score",
        posi_intent: "Intent",
        // Distinct from `amount` (also "Budget"): the deal budget and the
        // POSI budget answer are different questions shown on the same form.
        posi_budget: "Budget (POSI)",
        posi_payment_method: "Payment method",
        posi_decision_maker: "Decision maker",
        // Almikia Epic E3b (TASK-070): the lead reassignment owner picker,
        // shown only to direccion / lead_manager (never asesora or lider).
        sales_id: "Assigned to",
      },
      lead_types: {
        bpo: "BPO",
        proactivo: "Proactive",
        almikia: "Almikia",
        colega: "Broker",
      },
      // Almikia Epic EL3: plain-language definition of each lead TYPE (who generated the lead).
      lead_type_definitions: {
        bpo: "Generated by the developer with their own efforts.",
        almikia: "Generated by the agency with its own efforts.",
        proactivo:
          "Generated by an advisor, leader or direction as part of their own portfolio.",
        colega:
          "Exists because a fellow real-estate broker brings it with their own effort.",
      },
      protected_no_reassign: "Proactive and broker leads are not reassigned",
      protected_use_action:
        "This lead is proactive or broker. To change advisor use Reassign (Direction).",
      owner_auto_hint: "It will be assigned automatically",
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
        // Almikia Epic EA (TASK-111): opens `LogActivityForm` from the lead
        // show.
        log_activity: "Log activity",
      },
      field_categories: {
        misc: "Misc",
        posi: "POSI",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      special_states: {
        title: "Other states",
        empty: "No leads in this state.",
      },
      prospect_inbox: {
        title: "Prospecto",
        empty: "No leads in the Prospecto inbox.",
        elapsed: "%{hours}h ago",
        flags: {
          on_time: "On time",
          due_soon: "Due soon",
          overdue: "Over 24h",
        },
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
      posi_gate_blocked:
        "Complete the 4 POSI questions before moving the lead to Showing",
      stage_archived_marker: "Stage archived",
      stage_empty: "No leads in this stage. Drop one here.",
      archived_stage_drop_blocked:
        "This stage is archived; it can no longer receive new leads",
      // Almikia Epic EP (TASK-108), DATA CONTRACT EP (9): `%{items}` is
      // already the joined Spanish item list from `stageReadiness.ts`
      // (never invented in another language -- same items every locale).
      stage_readiness: {
        met: "Ready for %{stage}",
        missing: "Missing %{items} for %{stage}",
      },
      // Almikia Epic EA (TASK-111), vision #4: "Log activity" -- one form
      // that logs the activity + result + optional note and sets the
      // next-step task in a single save.
      activity_log: {
        title: "Log activity",
        activity_label: "Activity",
        groups: {
          stage: "For this stage",
          other: "Other activities",
        },
        result_label: "Result",
        message: {
          copy: "Copy message",
        },
        note_label: "Note (optional)",
        empty: "No activities available",
        error_loading: "Activities could not be loaded",
        save: "Save",
        save_error: "The activity could not be logged",
        success: "Activity logged",
        next_step: {
          label: "Next step: %{activity} · %{date}",
          due_at_label: "Next step date and time",
          none: "No next step",
          no_contact: "Add a contact to this lead to schedule the next step",
          attempts_exhausted: "The attempt limit for the next step was reached",
          next_activity_archived: "The next activity is no longer available",
        },
      },
      next_step: {
        title: "Next step",
        none: "No next step scheduled",
        overdue: "Overdue",
      },
      // Almikia Epic EF (TASK-119): 'Perfil del cliente'. English parity
      // only -- the shipped UI language is Spanish (see spanishCrmMessages.ts).
      deal_profile: {
        title: "Customer profile",
        header_count: "%{count} of %{total} fields",
        error_loading: "The profile could not be loaded",
        groups: {
          who: "Who they are",
          looking_for: "What they're looking for",
          payment: "How they pay",
          timing: "When and why",
        },
        fields: {
          buyer_type: "Buyer type",
          decision_maker: "Who decides",
          decision_maker_hint: "Captured in POSI",
          decision_maker_empty: "No answer yet",
          sells_other_property: "Selling another property",
          property_type: "Property type",
          bedrooms: "Bedrooms",
          zone: "Area",
          compared_projects: "Projects being compared",
          budget_min: "Budget from",
          budget_max: "Budget up to",
          credit_type: "Credit",
          down_payment: "Down payment",
          monthly_payment: "Monthly payment",
          timeline: "Timeline",
          interest_level: "Interest",
          motivators: "Motivators",
          objections: "Objections",
          notes: "Profile notes",
        },
        status: {
          saving: "Saving…",
          saved: "Saved a few seconds ago",
          error: "Couldn't save. Try again.",
        },
      },
    },
    developers: {
      name: "Developer |||| Developers",
      fields: {
        legal_name: "Legal name",
        rfc: "RFC",
        fiscal_zip_code: "Fiscal zip code",
        tax_regime: "Tax regime",
        cfdi_use: "CFDI use",
        invoice_email: "Invoice email",
        authorization_to_sell_status: "Authorization to sell status",
      },
      authorization_to_sell_status: {
        pendiente: "Pending",
        validado: "Validated",
      },
      fiscal: {
        title: "Fiscal data",
        updated: "Fiscal data updated",
        update_error: "An error occurred. Please try again",
      },
      fiscal_documents: {
        title: "Constancia de Situacion Fiscal",
        upload_button: "Upload Constancia",
        upload_success: "Constancia uploaded",
        upload_error: "The Constancia could not be uploaded. Please try again",
        error_invalid_type: "Only PDF files are accepted",
        error_too_large: "The file exceeds the 10 MB limit",
        view: "View",
        view_error: "The document could not be opened. Please try again",
        uploaded_by_unknown: "Unknown user",
        empty: "No versions uploaded yet",
      },
      empty: {
        description: "It seems your developer list is empty.",
        title: "No developers found",
      },
    },
    projects: {
      name: "Project |||| Projects",
      fields: {
        name: "Name",
        code: "Code",
        developer_id: "Developer",
        compliance_pack_status: "Compliance pack status",
        invoice_concept_template: "Invoice concept template",
        invoice_concept_template_version: "Template version",
        archived: "Archived",
      },
      compliance_pack_status: {
        pendiente: "Pending",
        validado: "Validated",
      },
      archived_status: {
        active: "Active",
        archived: "Archived",
      },
      empty: {
        description: "It seems your project list is empty.",
        title: "No projects found",
      },
    },
    units: {
      name: "Unit |||| Units",
      fields: {
        project_id: "Project",
        identifier: "Identifier",
        type: "Type",
        status: "Status",
        list_price: "List price",
      },
      type: {
        depto: "Apartment",
        local: "Commercial unit",
        lote: "Lot",
      },
      status: {
        disponible: "Available",
        apartada: "Reserved",
        vendida: "Sold",
      },
    },
    incentive_programs: {
      name: "Incentive |||| Incentives",
      fields: {
        name: "Name",
        scope: "Scope",
        period: "Period",
        validity: "Validity",
        parameters_summary: "Parameters",
        rate_pct: "Rate (%)",
        cap_mxn_per_sale: "Cap per sale (MXN)",
        min_level: "Minimum level",
        min_units: "Minimum units",
        tiers: "Tiers",
        tier_threshold_mxn: "Threshold (MXN)",
        tier_rate_pct: "Tier rate (%)",
        tier_inclusive: "Inclusive threshold",
        target_appointments: "Appointment target",
        reward_max_mxn: "Maximum reward (MXN)",
        valid_from: "Valid from",
        valid_to: "Valid to",
      },
      scope: {
        advisor: "Advisor",
        team: "Team",
      },
      period: {
        month: "Monthly",
        quarter: "Quarterly",
        accumulated: "Accumulated",
      },
      validity: {
        open_ended: "Since %{from}",
        range: "%{from} - %{to}",
      },
      summary: {
        monthly_sale_incentive: "%{rate} % per sale, cap %{cap}",
        quarterly_outstanding_sales:
          "Minimum %{min_units} units, %{tiers_count} commission tiers",
        monthly_proactive_appointments:
          "%{target} appointments, maximum reward %{reward}",
        no_parameters: "No parameters defined yet",
      },
      no_parameters_yet: "This incentive's rules aren't defined yet.",
      action: {
        new_vigencia: "New validity period",
      },
      new_vigencia: {
        title: "New validity period for %{name}",
        success: "New validity period created",
        error: "Couldn't create the new validity period. Please try again.",
      },
      empty: {
        title: "No incentives found",
        description: "No incentive programs are configured yet.",
      },
    },
    deal_stage_configs: {
      name: "Stage |||| Stages",
      title: "Stages and advance criteria",
      fields: {
        key: "Key",
        key_help: "The key can't be changed once the stage is created.",
        label: "Name",
        placement: "Placement",
        target_hours: "Target time",
        required_activities: "Stage activities",
      },
      group: {
        inbox: "Inbox",
        kanban: "Board",
        special: "Special states",
      },
      system_marker: "Base stage",
      archived_marker: "Archived",
      criteria: {
        none: "No criteria",
        title: "Advance criteria",
        enabled: "Enabled",
        disabled: "Disabled",
        confirm_off_title: "Turn off this criterion?",
        confirm_off_body:
          "Leads will be able to enter this stage without having answered the 4 POSI questions.",
        confirm_off_action: "Yes, turn it off",
      },
      target_time: {
        none: "No target time",
        hours: "%{smart_count} h",
        days: "%{smart_count} day |||| %{smart_count} days",
        unit_hours: "Hours",
        unit_days: "Days",
        help: "Expected time in this stage. Informational only for now.",
      },
      required_activities: {
        placeholder: "Add an activity and press Enter",
        help: "Informational list only: nothing is validated or blocked by it yet.",
        limit: "Up to %{max} activities",
      },
      activities: {
        catalogue_title: "Catalogue activities",
        empty: "No activities in the catalogue yet.",
        none: "No activities",
        archived_marker: "Archived",
        save_action: "Save links",
        saved: "Activity links saved",
        unsaved_links_warning:
          "You have unsaved activity links. Save or discard them before saving the stage.",
      },
      alerts: {
        title: "Alerts",
        empty: "No configurable alerts for this stage yet.",
      },
      action: {
        new_stage: "New stage",
        move_up: "Move up",
        move_down: "Move down",
        archive: "Archive",
        reactivate: "Reactivate",
      },
      new_stage: {
        placement_help:
          "Choose whether the new stage appears on the Board or as a Special state.",
      },
      archive: {
        system_reason: "Base stages can't be archived.",
        archived: "Stage archived",
        reactivated: "Stage reactivated",
        confirm_archive_title: "Archive this stage?",
        confirm_archive_body:
          "Leads already in this stage stay there. You can reactivate it later.",
        confirm_reactivate_title: "Reactivate this stage?",
        confirm_reactivate_body:
          "The stage will be available to assign leads again.",
      },
      error: {
        label_required: "The stage's name is required",
        label_too_long: "The stage's name can't exceed 40 characters",
        label_duplicate: "An active stage already uses that name",
        activities_too_many: "You can add up to 10 activities",
        activities_invalid:
          "Each activity needs text and at most 80 characters",
        target_time_invalid: "The target time must be greater than 0",
        not_authorized: "Only Direction can change the stages",
        generic: "Couldn't save the change. Please try again.",
      },
    },
    deal_activity_types: {
      name: "Activity |||| Activities",
      title: "Activities",
      fields: {
        name: "Name",
        message_template: "Message",
        message_template_help:
          "You can use {nombre}, {asesora} and {proyecto}; they're filled in automatically when the message is used.",
        message_preview: "Preview",
        max_attempts: "Attempt cap",
        max_attempts_help:
          "Leave it empty if this activity has no attempt limit.",
      },
      results_count:
        "%{smart_count} active result |||| %{smart_count} active results",
      cap_label: "Max %{max} attempts",
      archived_marker: "Archived",
      empty: "No activities in the catalogue yet.",
      action: {
        new_activity: "New activity",
        archive: "Archive",
        reactivate: "Reactivate",
      },
      archive: {
        archived: "Activity archived",
        reactivated: "Activity reactivated",
        confirm_archive_title: "Archive this activity?",
        confirm_archive_body:
          "Past activity log entries are kept. The activity will stop appearing to log new activities and as a next step; you can reactivate it later.",
        confirm_reactivate_title: "Reactivate this activity?",
        confirm_reactivate_body:
          "The activity will be available to log and as a next step again.",
      },
      error: {
        name_required: "The activity's name is required",
        name_too_long: "The activity's name can't exceed 80 characters",
        name_duplicate: "An active activity already uses that name",
        message_template_too_long: "The message can't exceed 1000 characters",
        max_attempts_invalid:
          "The attempt cap must be a number between 1 and 10",
        not_authorized: "Only Direction can change the activity catalogue",
        generic: "Couldn't save the change. Please try again.",
      },
    },
    deal_activity_results: {
      title: "Possible results",
      title_new: "New result",
      title_edit: "Edit result",
      fields: {
        label: "Label",
        message_template: "Message",
        message_template_help:
          "You can use {nombre}, {asesora} and {proyecto}; they're filled in automatically when the message is used.",
        message_preview: "Preview",
        next_activity_type_id: "Next activity",
        no_next_activity: "No next step",
        next_step_offset_hours: "Hours until the next step",
        next_step_offset_help: "Required when you choose a next activity.",
      },
      rule_summary: "Next step: %{activity} in %{hours} h",
      rule_summary_none: "No next step",
      archived_marker: "Archived",
      next_activity_archived_marker: "Next step archived",
      empty: "This activity has no results yet.",
      action: {
        new_result: "New result",
        archive: "Archive",
        reactivate: "Reactivate",
      },
      notifications: {
        created: "Result created",
        updated: "Result updated",
      },
      archive: {
        archived: "Result archived",
        reactivated: "Result reactivated",
        confirm_archive_title: "Archive this result?",
        confirm_archive_body:
          "Past activity log entries are kept. The result will stop being available when logging an activity; you can reactivate it later.",
        confirm_reactivate_title: "Reactivate this result?",
        confirm_reactivate_body:
          "The result will be available again when logging an activity.",
      },
      error: {
        label_required: "The result's label is required",
        label_too_long: "The result's label can't exceed 80 characters",
        label_duplicate:
          "An active result of this activity already uses that label",
        message_template_too_long: "The message can't exceed 1000 characters",
        offset_required:
          "The next step's hours are required when you choose a next activity",
        offset_invalid:
          "The next step's hours must be a number between 0 and 2160",
        not_authorized: "Only Direction can change the activity catalogue",
        generic: "Couldn't save the change. Please try again.",
      },
    },
    alert_rules: {
      name: "Alert rule |||| Alert rules",
      title: "Alerts",
      fields: {
        label: "Label",
        enabled: "Enabled",
        hours_threshold: "Hours",
        stuck_lead_count_threshold: "Number of leads",
        target_stage_key: "Target stage",
        appointment_activity_type_id: "Appointment activity",
      },
      status: {
        enabled: "Enabled",
        disabled: "Disabled",
      },
      threshold: {
        hours: "%{smart_count} hour |||| %{smart_count} hours",
        stuck_count: "%{smart_count} lead |||| %{smart_count} leads",
        stage_activity: "%{stage} · %{activity}",
      },
      description: {
        sin_seguimiento:
          "We alert you when a lead goes more than %{hours} h without a follow-up.",
        detenido_en_etapa:
          "We alert you when %{count} leads or more stay stuck in the same stage longer than expected.",
        cumple_criterio_sin_cita:
          "We alert you when a lead meets the criteria for %{stage} but still has no %{activity} scheduled.",
        alta_intencion_sin_actividad:
          "We alert you when a high-intent lead goes more than %{hours} h with no activity logged.",
      },
      detenido_en_etapa: {
        title: "Stages with a target time",
        help: "This rule only applies to stages that have a target time configured.",
        empty: "No stages have a target time configured yet.",
        link: "Go to Stages",
      },
      empty: "No alert rules configured yet.",
      error: {
        hours_threshold_required: "Enter the hours",
        hours_threshold_invalid:
          "The hours must be a number between 1 and 2160",
        stuck_lead_count_required: "Enter the number of leads",
        stuck_lead_count_invalid:
          "The number of leads must be a number between 1 and 100",
        target_stage_required: "Choose the target stage",
        appointment_activity_required: "Choose the appointment activity",
        not_authorized:
          "Only Direction can change the alert rules configuration",
        generic: "Couldn't save the change. Please try again.",
      },
    },
    profile_buyer_types: { title: "Buyer type" },
    profile_credit_types: { title: "Credit type" },
    profile_timelines: { title: "Timeline" },
    profile_motivators: { title: "Motivators" },
    profile_objections: { title: "Objections" },
    lead_sources: {
      name: "Lead source |||| Lead sources",
      fields: {
        name: "Name",
        color: "Color",
        active: "Active",
        meta_mapping: "Meta mapping",
      },
    },
    meta_form_projects: {
      name: "Meta form |||| Meta forms",
      fields: { meta_form_id: "Meta form id", project_id: "Project" },
    },
    property_options: {
      name: "Property |||| Inventario Almikia",
      fields: {
        address: "Address",
        zone: "Zone",
        property_type: "Type",
        price: "Price",
        status: "Status",
        responsable: "Responsible",
        origin: "Origin",
        operation: "Operation",
        furnished: "Furnished",
        exclusivity_signed_on: "Contract signing",
        exclusivity_ends_on: "Term end",
        levels: "Levels",
        bedrooms: "Bedrooms",
        bathrooms: "Bathrooms",
        area_m2: "Area (m²)",
        parking: "Parking",
        specs: "Specifications",
      },
      empty: {
        title: "There are no properties in the Inventario Almikia yet",
        description:
          "The Inventario Almikia gathers the options, exclusives and BPO project units that you can offer to your clients.",
      },
    },
    inventory_items: {
      name: "Inventario Almikia |||| Inventario Almikia",
    },
    property_option_owners: {
      name: "Owner |||| Owners",
      fields: {
        full_name: "Owner's name",
        phone: "Phone",
        email: "Email",
        notes: "Notes",
      },
    },
    colegas: {
      name: "Colega |||| Colegas",
      fields: {
        full_name: "Full name",
        phone: "Phone (10 digits)",
        brokerage: "Brokerage",
        independent: "Independent",
        email: "Email",
        notes: "Notes",
        active: "Active",
        created_by: "Registered by",
      },
    },
    operations: {
      name: "Operation |||| Operations",
      empty: {
        title: "No operations found",
        description:
          "Operations appear when you reserve a unit on a lead in closing.",
      },
    },
    // Almikia Epic E6 (TASK-039): invoicing resources.
    receivables: {
      name: "Receivable |||| Receivables",
      empty: {
        title: "No receivables found",
        description:
          "Receivables appear when a sale is signed or the VoBo of a brokerage sale is approved.",
      },
    },
    payables: {
      name: "Payable |||| Payables",
      empty: {
        title: "No payables found",
        description:
          "Payables appear when the file is green and the advisor uploads her invoice.",
      },
    },
    // Almikia Epic EG (TASK-044): expenses.
    expenses: {
      name: "Expense |||| Expenses",
      empty: {
        title: "No expenses found",
        description:
          "The agency's expenses are listed here, with their category, amount and who paid.",
      },
    },
    expense_categories: {
      name: "Expense category |||| Expense categories",
    },
    clients: {
      name: "Client |||| Clients",
      fields: {
        client_type: "Client type",
        full_legal_name: "Full legal name",
        rfc: "RFC",
        curp: "CURP",
        birthday: "Birthday",
        marital_status: "Marital status",
        marital_property_regime: "Marital property regime",
        children_count: "Number of children",
        email: "Email",
        phone: "Phone",
        address: "Address",
        contact_id: "Linked contact",
        sales_id: "Owner",
      },
      client_type: {
        persona_fisica: "Individual",
        persona_moral: "Legal entity",
      },
      marital_status: {
        soltero: "Single",
        casado: "Married",
        union_libre: "Domestic partnership",
        divorciado: "Divorced",
        viudo: "Widowed",
      },
      marital_property_regime: {
        sociedad_conyugal: "Community property",
        separacion_bienes: "Separate property",
      },
      filters: {
        only_mine: "Only my clients",
      },
      empty: {
        description: "It looks like your client list is empty.",
        title: "No clients found",
      },
      helper: {
        full_legal_name: "Write it exactly as on the official ID",
      },
      warnings: {
        rfc_duplicate: "This RFC is already registered for another client.",
      },
      action: {
        create: "Create Client",
        new: "New Client",
      },
      linked_leads: {
        title: "Linked leads",
        empty: "No leads linked to this client.",
      },
      upcoming_birthdays: {
        title: "Upcoming birthdays",
        empty: "You have no client birthdays in the next 30 days.",
      },
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      // Almikia Epic EA (TASK-111): marks a `deal_notes` row created by
      // `logDealActivity` (both `activity_type_id`/`activity_result_id` set)
      // in the notes trail, next to a plain note.
      activity_marker: "Activity",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        role: "Role",
        disabled: "Disabled",
        business_arm: "Business unit",
        business_arm_review: "Review business unit",
        reports_to: "Mentorship",
        advisor_code: "Advisor code",
        projects: "Projects",
        accumulated_sales: "Accumulated sales to date",
        accumulated_sales_helper:
          "Captured once at onboarding and counted together with the CRM's own sales to compute the level.",
        accumulated_sales_invalid: "Enter a whole number of sales (0 or more)",
        level: "Level",
        level_empty: "No level computed",
        corretaje_projects_blocked:
          "Corretaje people have no projects. End their active projects before saving this change.",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
      empty: {
        description: "It seems your user list is empty.",
        title: "No users found",
      },
      pending_claims: {
        title: "Pending claves to confirm",
        roster_clave: "Clave (roster)",
        projects: "Projects",
        lider_bpo_marker: "%{name} (Líder BPO)",
        confirm: "Confirm",
        reject: "Reject",
        confirm_title: "Confirm clave",
        confirm_description:
          "This will apply the following changes to %{name}:",
        reject_title: "Reject clave",
        reject_description:
          "%{name} will be able to claim this row again later. Her profile is left unchanged.",
        confirm_success: "Clave confirmed",
        reject_success: "Clave rejected",
        direccion_only: "Only Dirección can confirm it",
        empty_title: "No pending claves",
        empty_description:
          "Once someone claims a roster clave, it appears here.",
      },
      projects: {
        title: "Projects",
        lider_bpo: "Líder BPO",
        lider_bpo_marker: "%{name} (Líder BPO)",
        empty: "No active projects",
        add_project: "Add a project",
        add: "Add",
        added: "Project added",
        add_error: "An error occurred while adding the project.",
        mark_lider: "Mark Líder BPO",
        clear_lider: "Clear Líder BPO",
        end: "End",
        end_title: "End membership",
        end_description:
          "%{name} will stop appearing as an active project for this person.",
        ended: "Membership ended",
        update_error: "An error occurred. Please try again.",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
    // Almikia Epic EL2 (TASK-074): "Guardias y asignación" project screen. One namespace; a
    // vitest test scans it for the forbidden vocabulary and checks the key sets match.
    guardias: {
      nav: "Guardias and assignment",
      title: "Guardias and assignment",
      intro:
        "See who is on guardia and who receives the new leads of the project.",
      project_label: "Project",
      no_projects: "You have no projects with this section yet.",
      no_access: "You do not have access to this section.",
      readonly_note:
        "You can see this section. You can only edit your own availability and your own unavailable ranges.",
      availability_link: "Mark my availability",
      availability_help:
        "Your guardias are built from the availability you mark. Nothing is imposed.",
      advisors_title: "Project advisors",
      advisors_help:
        "Only active advisors take part in the automatic assignment of new leads.",
      advisors_empty: "This project has no active advisors.",
      active_label: "Active",
      active_aria: "Mark %{name} as active in the project",
      now_title: "In the sales room now",
      now_empty: "Nobody is on guardia right now.",
      now_you: "You are on guardia now",
      roster_title: "Guardias of the week",
      roster_help:
        "Each guardia is built from the availability the advisor marked.",
      week_prev: "Previous week",
      week_next: "Next week",
      week_range: "Week of %{from} to %{to}",
      day_empty: "No guardias",
      guardia_range: "%{start} to %{end}",
      mine_title: "My guardias this week",
      mine_empty: "You have no guardias this week.",
      form_title: "Add a guardia",
      form_advisor: "Advisor",
      form_day: "Day",
      form_window: "Marked availability",
      form_start: "From",
      form_end: "To",
      form_add: "Add guardia",
      form_no_availability:
        "This advisor has not marked availability that day. Ask her to mark it first.",
      form_outside: "The guardia must stay inside the availability marked.",
      form_failed: "The guardia could not be saved.",
      guardia_end: "Remove",
      guardia_end_aria: "Remove the guardia of %{name} on %{day} at %{start}",
      hours_title: "Sales room opening hours",
      hours_help:
        "Display only. Leave both times empty for a closed day. Times are in Mexico City.",
      hours_open: "Opens",
      hours_close: "Closes",
      hours_save: "Save opening hours",
      hours_error_required: "Write both times for %{day}, or leave both empty.",
      hours_error_order: "On %{day}, the closing time must be after opening.",
      unavailable_title: "Unavailable",
      unavailable_help:
        "While an advisor is unavailable she does not receive new leads. Her leads stay with her.",
      unavailable_empty: "No unavailable ranges.",
      unavailable_advisor: "Advisor",
      unavailable_start_date: "From day",
      unavailable_start_time: "Start time",
      unavailable_end_date: "Until day",
      unavailable_end_time: "End time",
      unavailable_add: "Mark unavailable",
      unavailable_cancel: "Cancel",
      unavailable_cancel_aria: "Cancel the unavailable range of %{name}",
      unavailable_range: "%{start} to %{end}",
      unavailable_error_required: "Choose both days and both times.",
      unavailable_error_order: "The end must be after the start.",
      notices_title: "Notices",
      notices_help:
        "Follow-up notices of the lead assignment, newest first. Open the lead to see whether a contact was logged.",
      notices_empty: "There are no notices.",
      notice_lead_fallback: "Lead %{id}",
      notice_kind: {
        aviso_10_min: "10 minutes without contact",
        reasignacion_24h: "Reassigned after 24 hours without contact",
        sin_asesora_disponible:
          "No advisor available, the Team Leader was notified",
        reasignacion_tope:
          "The lead hit the reassignment cap and went to the Team Leader",
        alerta_cadencia_2d: "Two days without contact with the lead",
        sugerencia_cerrado_perdido:
          "Suggestion: move the lead to Closed lost for lack of response",
      },
      notice_kind_protected: {
        aviso_10_min:
          "10 minutes without contact. This lead is not reassigned automatically",
      },
      notice_gap_since: "No contact since %{date}",
      accept_suggestion: "Accept suggestion",
      loss_reason_prefix: "Closing reason",
      suggestion_accepted: "The lead moved to Closed lost.",
      suggestion_error: "Could not move the lead to Closed lost.",
      suggestion_note_error:
        "The lead is now Closed lost, but the loss reason note could not be saved. Add it manually.",
      limits_title: "Lead assignment limits",
      cap_label: "Maximum open unattended leads per advisor",
      cap_help:
        "A lead is unattended when it is assigned, in Prospecto or Contacto inicial, and has no contact logged. Empty means no limit.",
      overdue_label: "Overdue threshold (hours)",
      overdue_help:
        "A lead is overdue when it is in Contacto inicial or Discovery and its last activity is older than this threshold. Empty means no limit.",
      no_limit: "No limit",
      limits_save: "Save limits",
      limit_error:
        "Write a whole number greater than zero, or leave the field empty.",
      saved: "Changes saved",
      save_error: "Could not save. Please try again.",
      auto_assigned: "Lead assigned to %{name}. Reason: %{reason}.",
      reason_label: "Reason: %{reason}",
      weekday: {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        7: "Sunday",
      },
      reason: {
        lead_nuevo: "New lead",
        proteccion_90_dias: "90-day protection",
        fallback_omision: "Default reassignment",
        aviso_10_min: "10-minute notice",
        reasignacion_24h: "24-hour reassignment",
        manual: "Manual",
        reasignacion_direccion: "Management reassignment",
        reasignacion_lider: "Team Leader reassignment",
        baja_de_asesora: "Advisor departure",
        tope_reasignaciones: "Reassignment cap: passes to the Team Leader",
      },
    },
  },
  crm: {
    team_status_filter: {
      label: "Team member status",
      active: "Active",
      departed: "Departed",
    },
    // Almikia Epic EC2b (TASK-126): the contact file's "Expediente" tab.
    contact_expediente: {
      tab_general: "General data",
      tab_file: "File",
      loading: "Loading the file",
      retry: "Try again",
      denied: "You do not have access to this contact's file.",
      load_error: "We could not load the file. Try again in a moment.",
      saved: "Saved",
      save: "Save",
      saving: "Saving",
      save_hint:
        "You can save at any time, even with data missing. Nothing is required to save.",
      progress: "%{done} of %{total}",
      progress_label: "File progress",
      missing_title: "What is missing",
      complete_title: "The file is complete",
      who_uploads:
        "It is filled in by the contact's owner, her leader, Direccion, administration or compliance.",
      kind_title: "Type of person",
      section_fisica: "Individual details",
      section_moral: "Company details",
      section_address: "Address",
      section_id: "Official ID",
      section_pld: "Anti-money laundering",
      section_docs: "Documents",
      yes: "Yes",
      no: "No",
      choose: "Choose",
      owner_self: "It is the same person",
      owner_other: "It is someone else",
      id_expired: "The ID is expired. Enter a valid one.",
      regime_required: "State the marital property regime",
      owner_name_required: "State the name of the controlling beneficiary",
      kind_required: "Choose the type of person (individual or company)",
      doc_uploaded: "Uploaded",
      doc_missing: "Missing",
      doc_optional: "Optional",
      doc_by: "Uploaded by the owner or her leader",
      doc_pep_required: "Required because the person is politically exposed",
      doc_upload: "Upload file",
      doc_replace: "Replace",
      doc_view: "View",
      doc_remove: "Remove",
      doc_remove_title: "Remove document",
      doc_remove_hint:
        "The file stays in the record; it just stops counting as current.",
      doc_working: "Working",
      restricted_title: "What is missing in this file",
      restricted_note:
        "Only the contact's owner, her leader, Direccion, administration and compliance fill in and see the file data.",
      restricted_empty: "Nothing is missing in this file.",
      restricted_error:
        "We could not check what is missing. Try again in a moment.",
    },
    // Almikia Epic EN (TASK-091): internal WhatsApp notices UI.
    internalNotices: {
      roles: {
        direccion: "Direction",
        lead_manager: "Lead Manager",
        lider: "Leader",
        asesora: "Advisor",
        administracion: "Administration",
      },
      settings: {
        nav: "Internal notices",
        manage_link: "Configure internal notices",
        title: "Internal notices",
        intro:
          "Choose who receives the internal WhatsApp notices, check the usage of the notices number and send a test notice.",
        state_off: "Off (default)",
        state_on:
          "On for %{smart_count} person |||| On for %{smart_count} people",
      },
      users: {
        title: "People",
        help: "Notices are off for everyone until you switch them on one by one.",
        load_error: "The list of people could not be loaded",
        empty: "There are no active people to show",
        switch_label: "Internal notices for %{name}",
        general_summary_label: "%{name} receives the general summary",
        phone_yes: "Phone registered",
        phone_no: "No phone",
        no_phone_reason:
          "Cannot be switched on: this person has no registered +52 phone.",
        toggle_error: "The internal notice could not be changed. Try again",
        summary_error: "The general summary could not be changed. Try again",
        show_more: "Show more people",
      },
      usage: {
        title: "Notices number",
        month_label: "Month",
        used: "%{used} of %{quota} free service messages used",
        progress_label: "Service messages used this month",
        warning_80: "You have used 80% of this month's free messages",
        warning_100:
          "You reached the free limit: further service messages will have a cost",
        paid_templates: "Paid templates: %{count}",
        error: "The usage of the notices number could not be loaded",
        note: "Only messages of the notices number are counted. No phone is ever shown here.",
      },
      test: {
        button: "Send test notice",
        button_for: "Send test notice to %{name}",
        sending: "Sending...",
        success: "Test notice sent",
        error: "The test notice could not be sent. Try later",
      },
      config: {
        title: "Configuration",
        window: "Grouping window (minutes)",
        window_help:
          "New leads arriving within this window are grouped into a single notice.",
        weekends: "Also send summaries on weekends",
        holidays: "Holidays (no summary)",
        holidays_help: "One date per line, formatted YYYY-MM-DD.",
        invalid:
          "Check the values: the window must be a whole number above 0 and the dates must be formatted YYYY-MM-DD.",
        saved: "Configuration saved",
        save_error: "The configuration could not be saved. Try again",
        load_error: "The configuration could not be loaded",
      },
      profile: {
        summaries_label: "Receive the 8:30 and 20:30 summaries",
        summaries_help:
          "New-lead and urgent notices are not affected by this option.",
        saved: "Preference saved",
        error: "Your preference could not be saved. Try again",
      },
      take: {
        line: "Taken by %{name} on %{date}",
      },
    },
    action: {
      reset_password: "Reset Password",
    },
    // Almikia Epic E3b (TASK-067): sign-in prompt asking a clave-less
    // asesora for her advisor code ("Not now" postpones it).
    advisorCodePrompt: {
      title: "Add your advisor code",
      description:
        "You need your advisor code to receive leads. Add it whenever you have it; you can also do it later from your profile.",
      postpone: "Not now",
      saved: "Your advisor code has been saved",
      required: "Write your advisor code to save it",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      official_email_required:
        "Only @almikia.com email addresses can create an account.",
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading…",
      list_error: "The list could not be loaded.",
      test_data_badge: "Test data",
      test_data_filter_label: "Test data",
      test_data_filter_all: "Include test data",
      test_data_filter_only: "Only test data",
      test_data_filter_hide: "Hide test data",
      clear_filters: "Clear filters",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
      value_of: "%{count} of %{total}",
    },
    changelog: {
      title: "Changelog",
    },
    // Almikia Epic EO (TASK-098): the "Almikia" section landing, one tap
    // away from the desktop rail / mobile bottom navigation for every role.
    almikia: {
      nav_label: "Almikia",
      title: "Almikia",
      organigrama_entry: "Org chart",
      cultura_entry: "Our culture",
    },
    // Almikia Epic EO (TASK-098): the "Organigrama" screen. Position labels,
    // brazo/group section headers, the "Líder BPO" marker and the
    // Coordinación/Acompañamiento relationship words are fixed Spanish
    // business vocabulary (see `orgChartLayout.ts` and `sales/roles.ts`),
    // shown as-is whatever the app locale -- never routed through these
    // per-locale keys.
    // Almikia Epic EC2c (TASK-133): quick-contact buttons of a team profile.
    team_contact: {
      whatsapp: "WhatsApp",
      call: "Call",
      email: "Email",
    },
    org_chart: {
      title: "Org chart",
      empty_title: "There is no one in the org chart yet",
      empty_description:
        "As soon as there are active people, they show up here.",
      card: {
        arm_label: "Business unit",
        level_label: "Level",
        projects_label: "Projects",
        relationship_label: "Relationship",
        advisor_code_label: "Advisor code",
        phone_label: "Phone",
        email_label: "Email",
      },
    },
    // Almikia Epic EO (TASK-099): the "Nuestra cultura" screen -- Visión,
    // Misión, Valores and Manifiesto, read from `culture_documents_current`
    // and shown verbatim (their titles/bodies are fixed business content,
    // never routed through per-locale keys; only the page chrome is here).
    culture: {
      title: "Our culture",
      empty_title: "There is no culture content yet",
      empty_description:
        "As soon as documents are published, you'll see them here.",
      action: {
        edit: "Edit",
        history: "History",
        new_document: "New document",
      },
      history: {
        title: "History of %{title}",
        empty: "There are no versions yet.",
        back_to_list: "Back to history",
        version_number: "Version %{number}",
        seeded: "Initial upload",
      },
      editor: {
        new_title: "New document",
        edit_title: "Edit %{title}",
        title_label: "Title",
        body_label: "Content (Markdown)",
        toolbar_label: "Text formatting",
        tab: {
          edit: "Edit",
          preview: "Preview",
        },
        preview_empty: "Type some content to see the preview.",
        format: {
          bold: "Bold",
          italic: "Italic",
          bullet: "Bulleted list",
          link: "Link",
        },
        action: {
          save: "Save new version",
        },
        success: "A new version was saved.",
        error: {
          title_required: "The title cannot be empty.",
          title_too_long: "The title cannot be longer than 120 characters.",
          body_required: "The content cannot be empty.",
          body_too_long: "The content cannot be longer than 20,000 characters.",
          no_changes: "There are no changes to save.",
          save_failed: "The new version could not be saved.",
        },
      },
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
      hoy: {
        greeting: "Hi, %{name}",
        ring_label: "Your plan for today",
        ring_title: "Your plan for today",
        ring_unit: "of %{total}",
        plan_all_done: "You're all caught up. No touches pending.",
        plan_pending:
          "%{smart_count} touch left; the most urgent is %{name}. |||| %{smart_count} touches left; the most urgent is %{name}.",
        plan_pending_with_hours:
          "%{smart_count} touch left; the most urgent is %{name}, arrived %{hours} h ago. |||| %{smart_count} touches left; the most urgent is %{name}, arrived %{hours} h ago.",
        list_title: "Who needs you today",
        empty_title: "You have nothing pending today",
        empty_description:
          "No touches, birthdays or POSI answers left to complete.",
        action: {
          whatsapp: "Send WhatsApp",
          call: "Call",
          view_profile: "Customer profile",
        },
        reason: {
          prospect: "Lead with no reply yet",
          task_overdue: "Overdue task",
          task_today: "Task due today",
          // Almikia Epic EA (TASK-112): a catalogue next-step task names its
          // activity instead of the generic "Overdue task"/"Task due today".
          next_step_overdue: "%{activity} · overdue",
          next_step_today: "%{activity} · today",
          birthday_today: "Birthday today",
          birthday_tomorrow: "Birthday tomorrow",
          posi_incomplete: "POSI %{answered} of 4 · missing %{field}",
        },
        posi_field: {
          posi_intent: "intent",
          posi_budget: "budget",
          posi_payment_method: "payment method",
          posi_decision_maker: "decision maker",
        },
        my_progress_link: "See my progress",
      },
      lider: {
        greeting: "Hi, %{name}",
        my_day_link: "See my day",
        my_progress_link: "See my progress",
        team_goal_title: "Team vs the month's goal",
        no_goal: "No goal set",
        units_and_amount: "%{units} direct sales · %{amount}",
        units_missing:
          "%{smart_count} sale left to reach her goal |||| %{smart_count} sales left to reach her goal",
        goal_reached: "Goal reached",
        units_bar_label: "Unit progress against the goal",
        amount_progress: "%{actual} of %{target}",
        set_goal_action: "Set goal",
        team_title: "Your team",
        team_empty_title: "You don't have any advisors on your team yet",
        team_empty_description:
          "Once advisors are assigned to you, they show up here.",
        best_bpo_team_units_and_amount: "%{units} direct sales · %{amount}",
        funnel_title: "Team funnel",
        funnel_empty_title: "No open leads in your team",
        expiring_title: "Expiring soon",
        expiring_empty_title: "No leads expiring soon",
        expiring_hours: "%{hours} h",
        posi_incomplete_title: "Incomplete POSI",
        posi_incomplete_empty_title: "No leads with an incomplete POSI",
        pending_ops_title: "Operations with pending documents",
        pending_ops_empty_title: "No operations registered yet",
        pending_ops_empty_description:
          "Once operations are registered, they show up here.",
      },
      direccion: {
        eyebrow: "Management · %{period}",
        greeting: "Hi, %{name}",
        month_bar_days_left:
          "%{smart_count} day left |||| %{smart_count} days left",
        month_bar_need_sentence:
          "To reach %{target} sale you need %{missing} more |||| To reach %{target} sales you need %{missing} more",
        hero_title: "This month's direct sales",
        hero_units: "%{smart_count} sale |||| %{smart_count} sales",
        hero_units_of_target:
          "%{units} of %{target} sale |||| %{units} of %{target} sales",
        pipeline_title: "Pipeline · totals by stage",
        pipeline_row:
          "%{smart_count} lead · %{amount} |||| %{smart_count} leads · %{amount}",
        projects_title: "Projects · this month's sales",
        projects_empty: "No active projects yet.",
        project_sales_row:
          "%{smart_count} sale · %{amount} |||| %{smart_count} sales · %{amount}",
        posi_title: "Active leads with a complete POSI",
        posi_percent: "%{percent}%",
        posi_bar_label: "Percentage of active leads with a complete POSI",
        vobo_title: "Awaiting your sign-off",
        vobo_empty_title: "Nothing is awaiting your sign-off yet",
        vobo_empty_description:
          "Once something needs your authorization, it shows up here.",
        operations_title: "Operations by traffic light",
        operations_empty_title: "No operations registered yet",
        operations_empty_description:
          "Once operations are registered, they show up here.",
        collections_title: "Collections",
        collections_empty_title: "No collections information yet",
        collections_empty_description:
          "Once collections information exists, it shows up here.",
        partial_data_note:
          "Partial data: there are more than 1,000 records; this figure does not include them all.",
        // Almikia Epic ER (TASK-004, vision #13): the funnel section --
        // per-stage conversion/time, first-response/contactability
        // (direccion only) and the rule-based bottleneck narrative.
        funnel: {
          title: "Funnel · conversion and times",
          project_filter_label: "Project",
          lead_type_filter_label: "Lead type",
          advisor_filter_label: "Advisor",
          filter_all_option: "All",
          conversion_label: "Conversion to the next stage",
          conversion_percent: "%{percent}%",
          time_in_stage_label: "Median time in stage",
          time_hours: "%{hours} h",
          time_days: "%{days} d",
          leads_count: "%{smart_count} lead |||| %{smart_count} leads",
          no_data: "Not enough data",
          first_response_title: "First-response time",
          contactability_title: "Contactability",
          contactability_percent: "%{percent}%",
          empty_title: "No leads in this filter",
          empty_description: "Adjust the filters to see the funnel.",
        },
        // Almikia Epic ER (vision #12, TASK-008): the Direccion "leads that
        // need attention" section -- alerts grouped by rule, plus the
        // "N stuck in stage" highlight. A dedicated namespace block, distinct
        // from the advisor-facing `crm.dashboard.alerts` block below (the
        // alert SENTENCE itself is still plain-Spanish domain text, built by
        // `alerts/alertMessage.ts`, never translated here).
        alerts: {
          section_title: "Leads that need attention",
          empty_title: "No lead needs attention right now",
          rule_group_leads_count:
            "%{smart_count} lead |||| %{smart_count} leads",
          view_all: "View all (%{count})",
          stuck_stage_summary:
            "%{stage}: %{smart_count} lead |||| %{stage}: %{smart_count} leads",
          stuck_stage_highlight:
            "You have %{smart_count} lead stuck in %{stage} |||| You have %{smart_count} leads stuck in %{stage}",
        },
      },
    },
    // Almikia Epic ER (TASK-007): the advisor-facing lead-alert surfaces
    // (Hoy's alert cards, the lead page's alert pills) -- the alert
    // sentence itself is plain-Spanish domain text built by
    // `alerts/alertMessage.ts`, not translated here (same precedent as the
    // WhatsApp message templates below).
    alerts: {
      section_title: "Your leads' alerts",
      empty: "You have no pending alerts",
      view_all: "View all (%{count})",
    },
    // Almikia Epic EW1 (TASK-124): the shared "Enviar WhatsApp" action --
    // every label the wave-3 placements (Hoy, lead show, contact show) need,
    // so none of them adds its own i18n keys.
    whatsapp: {
      action_label: "Send WhatsApp to %{nombre}",
      chooser: {
        title: "Which lead is this for?",
        error: "We couldn't load your leads",
        open_without_logging: "Open without logging",
      },
      // Almikia Epic EW2 (TASK-079): conversation timeline, clock bars and composer.
      conversation: {
        title: "WhatsApp conversation",
        empty: "No WhatsApp messages yet",
        error: "The WhatsApp conversation could not be loaded",
        retry: "Retry",
        load_older: "Show earlier messages",
        sender: {
          customer: "Customer",
          app: "Pepe (app)",
          advisor_fallback: "Advisor",
        },
        status: {
          pending: "Sending",
          received: "Received",
          sent: "Sent",
          delivered: "Delivered",
          read: "Read",
          failed: "Failed: %{error}",
        },
        media: "Attachment (%{mime})",
        template_message: "Template: %{name}",
        clock: {
          free_text_title: "Free text",
          free_text_left: "%{time} left",
          free_text_closed: "Templates only",
          free_messages_title: "Free messages",
          free_messages_left: "%{time} left",
          free_messages_closed: "Messages now have a cost",
        },
        composer: {
          text_label: "WhatsApp message",
          placeholder: "Write your message",
          send: "Send",
          closed_notice:
            "The 24-hour window is closed: you can only send an approved template.",
          templates_off: "WhatsApp templates are not enabled yet.",
          template_label: "Template",
          template_placeholder: "Choose a template",
          variable_label: "Value for %{name}",
          cost_free: "Free",
          cost_paid: "Paid",
          confirm_title: "This template may have a cost",
          confirm_body:
            "Sending “%{name}” may add a charge to your WhatsApp account. Do you want to send it?",
          confirm_send: "Send with cost",
          cancel: "Cancel",
          sent_notice: "Message sent",
          send_error: "The message could not be sent",
        },
        send_errors: {
          ventana_cerrada:
            "The 24-hour window is closed: you can only send an approved template",
          confirmacion_costo: "This template has a cost: confirm the send",
          plantillas_deshabilitadas: "WhatsApp templates are not enabled yet",
          limite_envios: "You are sending too fast: wait a moment",
          envio_fallido: "The message could not be sent through WhatsApp",
          sin_configuracion: "WhatsApp is not configured: nothing was sent",
          desconocido: "The message could not be sent",
        },
      },
      not_recorded_notice:
        "WhatsApp opened, but the contact could not be recorded on the lead",
      // Almikia Epic EW3 (TASK-095): unclassified tray, personal numbers and the permission.
      // Almikia Epic EW4 (TASK-110): the read-only message thread of a tray / inbox row.
      thread: {
        show: "View messages",
        hide: "Hide messages",
      },
      unclassified: {
        nav: "Unclassified",
        settings_heading: "WhatsApp: classify contacts",
        title: "Unclassified",
        intro:
          "WhatsApp conversations that are not a lead yet. Choose whether it is a lead or a personal contact.",
        numbers_link: "Personal numbers",
        empty: "There are no unclassified conversations",
        error: "The unclassified conversations could not be loaded",
        show_more: "Show more",
        echo: "Pepe (app)",
        last_activity: "Last activity: %{at}",
        es_lead: "Is a lead",
        cancel: "Cancel",
        known_contact: "Known contact:",
        known_contact_open: "View contact",
        lead: {
          from_contact: "The lead is created from the contact %{name}.",
          unit: "Business unit",
          unit_bpo: "BPO",
          unit_corretaje: "Corretaje",
          mode_advisor_corretaje: "A corretaje advisor",
          mode_holder: "I keep it myself",
          title: "Classify as a lead",
          help: "Choose the project, the type and the origin of the lead, and who gets it.",
          choose: "Choose an option",
          project: "Project",
          type: "Lead type",
          source: "Origin",
          assign: "Assignment",
          mode_advisor: "Assign directly to an advisor",
          mode_carousel: "Send to the carousel",
          advisor: "Advisor",
          carousel_help:
            "The lead enters the carousel and is assigned by the entry rule.",
          submit: "Create lead",
          success: "Lead created.",
          open: "Open lead",
          error: "The lead could not be created. Please try again.",
        },
        errors: {
          project_required: "Choose the project",
          type_required: "Choose the lead type",
          source_required: "Choose the origin",
          advisor_required: "Choose the advisor",
          carousel_not_applicable:
            "The carousel only applies to BPO or Almikia leads",
        },
        personal: {
          action: "Personal",
          title: "Mark as personal",
          sentence:
            "This number is not business: its stored messages will be deleted and new ones will be ignored.",
          confirm: "Delete and mark as personal",
          success: "Number marked as personal.",
          error: "Could not mark it as personal. Please try again.",
        },
      },
      numbers: {
        nav: "Personal numbers",
        title: "Personal numbers",
        intro:
          "Messages from these numbers are ignored and not stored; only the count is kept.",
        tray_link: "Unclassified",
        paste_label: "Paste the numbers",
        paste_help:
          "One per line, or separated by commas or semicolons. You can also upload a CSV file.",
        file_label: "Or upload a CSV file",
        load: "Load list",
        empty_input: "Paste or upload at least one number",
        too_many: "At most %{max} numbers per load",
        load_error: "The list could not be loaded. Please try again.",
        result:
          "Loaded: %{loaded}. Duplicates: %{duplicates}. Rejected: %{rejected}.",
        list_title: "Current list",
        empty: "There are no personal numbers yet",
        error: "The personal numbers could not be loaded",
        ending: "Number ending in %{last4}",
        dropped: "Ignored messages: %{count}",
        last_seen: "Last message: %{at}",
        never_seen: "Has not written yet",
        remove: "Remove from the list",
        remove_help:
          "Messages that were already deleted are not restored. New ones will be stored again.",
        remove_confirm: "Remove",
        removed: "Number removed from the list.",
        remove_error: "Could not remove the number. Please try again.",
      },
      classify_permission: {
        title: "Classify WhatsApp contacts",
        label: "Can classify WhatsApp contacts",
        help: "Grants access to the Unclassified tray and the personal numbers.",
        on: "Permission granted.",
        off: "Permission removed.",
        error: "Could not change the permission. Please try again.",
      },
      // Almikia Epic EW2 (TASK-080): Inbox, counter, settings and lead-row badges.
      badges: {
        alert_24h: "Free-text window closing",
        alert_ctwa: "Free messages window closing",
        responde: "Replied",
        unread: "%{count} unread",
      },
      inbox: {
        nav: "WhatsApp inbox",
        title: "WhatsApp inbox",
        intro: "Your team's WhatsApp conversations. Open a lead to reply.",
        unmatched_title: "Without a lead",
        conversations_title: "Conversations",
        empty: "There are no WhatsApp conversations yet",
        empty_unmatched: "There are no conversations without a lead",
        error: "The WhatsApp inbox could not be loaded",
        pagination: "Inbox pagination",
        previous: "Previous",
        next: "Next",
        page_of: "Page %{page} of %{pages}",
        no_messages: "No messages",
        media_message: "Attachment",
        lead_fallback: "Lead",
        unmatched_name: "Conversation without a lead",
        window: {
          free_text: "Free text",
          ctwa: "Free messages",
          closed: "Templates only",
        },
        open_lead: "Open lead",
        link: "Link to a lead",
        create_lead: "Create lead",
        create_lead_desktop_only:
          "To create a lead, open the CRM on a computer.",
        create_error: "The lead could not be prepared. Try again",
        link_title: "Link conversation to a lead",
        link_help: "Choose the lead this conversation belongs to.",
        link_label: "Lead",
        link_placeholder: "Choose a lead",
        link_leads_error: "The leads could not be loaded",
        link_error: "The conversation could not be linked",
        link_success: "Conversation linked to the lead",
        link_confirm: "Link",
        cancel: "Cancel",
        link_after_create_error:
          "The lead was created, but the conversation could not be linked. Link it from the inbox",
      },
      health: {
        title: "WhatsApp connection",
        help: "Checks that both WhatsApp numbers respond. It does not send any message.",
        button: "Test WhatsApp connection",
        checking: "Testing…",
        retry: "Retry",
        inbox: "Customer inbox",
        alerts: "Internal notices",
        connected: "Connected",
        not_configured: "WhatsApp is not set up yet",
        meta_error: "Error %{code}: %{message}",
        error: "The connection could not be checked. Try again.",
      },
      counter: {
        title: "Service messages this month",
        month_label: "Month",
        number: "Inbox number",
        number_n: "Inbox number %{index}",
        used: "%{used} of %{quota} free messages used",
        progress_label: "Service messages used this month",
        warning: "You have used 80% of this month's free messages",
        full: "You reached the free limit: further service messages will have a cost",
        paid_templates: "Paid templates: %{count}",
        error: "The counter could not be loaded",
        empty: "No WhatsApp activity yet this month",
        note: "Messages sent from the WhatsApp Business app and templates do not count as service messages.",
      },
      settings: {
        nav: "WhatsApp",
        manage_link: "Configure WhatsApp",
        title: "WhatsApp settings",
        intro:
          "Windows, free quota, alerts, templates and go-live of the inbox WhatsApp number.",
        config_title: "Configuration",
        config_help:
          "These values are read from the server: change them here, not in code.",
        load_error: "The WhatsApp configuration could not be loaded",
        go_live_title: "Go-live",
        templates_enabled: "WhatsApp templates",
        templates_enabled_help:
          "Allows sending approved templates from the lead file.",
        welcome_enabled: "Welcome template",
        welcome_enabled_help:
          "Sends the welcome template to leads that arrive through a form.",
        flag_on: "On",
        flag_off: "Off (default)",
        window_direct: "Free-text window (hours)",
        window_direct_help:
          "Hours the window stays open after the customer's last message.",
        ctwa_free: "Free messages window (hours)",
        ctwa_free_help:
          "Free hours when the lead comes from an ad (7 days = 168).",
        quota: "Monthly free quota",
        quota_help: "Free service messages per month and per number.",
        alert_24h: "Free-text alert (hours left)",
        alert_24h_help: "A warning shows when fewer hours than this are left.",
        alert_ctwa: "Free messages alert (days left)",
        alert_ctwa_help: "A warning shows when fewer days than this are left.",
        rate_limit: "Sends per minute limit",
        rate_limit_help: "Maximum messages the CRM sends each minute.",
        welcome_title: "Welcome template",
        welcome_name: "Template name",
        welcome_language: "Language",
        welcome_variables: "Variables, in order",
        welcome_variables_help:
          "Comma-separated: first_name, project, advisor_name.",
        greeting: "Greeting for button leads",
        greeting_help: "Use {nombre} and {asesora}. 1,000 characters at most.",
        invalid: "Check these fields: %{fields}",
        field: {
          windowDirectHours: "Free-text window",
          ctwaFreeHours: "Free messages window",
          monthlyFreeQuota: "Monthly free quota",
          alert24hHoursLeft: "Free-text alert",
          alertCtwaDaysLeft: "Free messages alert",
          sendRateLimit: "Sends limit",
          welcomeName: "Welcome template name",
          welcomeLanguage: "Language",
          greeting: "Greeting",
        },
        save: "Save",
        saved: "Saved",
        save_error: "Could not save",
        templates_title: "Template catalogue",
        templates_help:
          "Templates are archived, never deleted. They must be approved in WhatsApp Manager.",
        templates_empty: "There are no templates yet",
        template_label: "Display name",
        template_name: "WhatsApp name (lowercase and _)",
        template_language: "Language (for example es_MX)",
        template_variables: "Variables, comma-separated",
        template_paid: "Has a cost",
        template_invalid:
          "Check the name (lowercase, digits and _), the language and the display name",
        template_add: "Add template",
        template_add_confirm: "Add",
        paid: "Paid",
        free: "Free",
        archived: "Archived",
        rename: "Edit",
        mark_free: "Mark as free",
        mark_paid: "Mark as paid",
        archive: "Archive",
        restore: "Restore",
      },
    },
    // Almikia Epic EI (TASK-004): AI copilot suggestion card and lead actions.
    ai: {
      card_aria: "AI suggestion",
      label: "✦ Suggestion · review it before sending",
      because: "Because:",
      send: "Send",
      edit: "Edit",
      dismiss: "Not now",
      apply: "Apply to profile",
      understood: "Got it",
      loading: "Preparing suggestion…",
      panel_title: "AI copilot",
      suggest_message: "Suggest message",
      whats_missing: "What am I missing?",
      objective_title: "What is the message for?",
      objectives: {
        showing: "Take them to a Showing",
        follow_up: "Pick the conversation back up",
        doubts: "Resolve a doubt",
        next_step: "Agree on the next step",
      },
      message_label: "Message",
      no_contact: "Add a contact with a phone number to send",
      chips_title: "Proposed profile data",
      questions_title: "Pending questions",
      missing_title: "What is missing",
      missing_because:
        "this data is not yet in the profile or in POSI for this lead.",
      nothing_missing: "Nothing is missing for now",
      edit_hint: "Adjust the client profile below",
      apply_error: "Could not apply to the profile. Try again.",
    },
    // Almikia Epic EL (TASK-009): the advisor's own "My availability" screen.
    availability: {
      nav: "My availability",
      title: "My availability",
      intro: "Choose the blocks in which you want to receive new leads.",
      list_title: "My blocks",
      time_zone: "Mexico City time (%{zone})",
      empty: "You have not chosen any blocks yet.",
      range: "from %{start} to %{end}",
      end: "End block",
      end_aria: "End the %{day} block starting at %{start}",
      add_title: "Add a block",
      weekday_label: "Day of the week",
      start_label: "From",
      end_label: "Until",
      add: "Add block",
      weekday_1: "Monday",
      weekday_2: "Tuesday",
      weekday_3: "Wednesday",
      weekday_4: "Thursday",
      weekday_5: "Friday",
      weekday_6: "Saturday",
      weekday_7: "Sunday",
      error_required: "Choose the day and enter both times.",
      error_end_not_after_start: "The end time must be after the start time.",
      error_overlap:
        "That block overlaps another one you already chose that day.",
      note: "Nothing is imposed: you choose. Outside your blocks you keep your own leads and only stop receiving new automatic ones.",
      saved: "Changes saved",
      save_error: "Could not save. Please try again.",
    },
    // Almikia Epic EL (TASK-010): "Assignment log" and "Assign automatically".
    // Almikia Epic EH (TASK-013): sales tools library and stage panel.
    salesTools: {
      nav: "Tools library",
      title: "Tools library",
      intro:
        "Scripts, questions, objection answers and material to support you at each stage. Use them whenever they help.",
      filter_search: "Search",
      filter_kind: "Type",
      filter_stage: "Stage",
      filter_project: "Project",
      filter_buyer_type: "Client type",
      all: "All",
      show_archived: "Show archived",
      archived: "Archived",
      empty: "No tools match these filters.",
      empty_title: "There are no tools yet",
      empty_description:
        "Scripts, questions and support material for each stage are collected here.",
      error: "Could not load the tools. Please try again.",
      open_link: "Open link",
      open_file: "Open file %{name}",
      file_error: "Could not open the file. Please try again.",
      panel_title: "Tools for this stage",
      panel_library_link: "See the whole library",
      panel_empty: "There are no tools for this stage yet.",
      panel_empty_hint:
        "Tools for this stage will appear here once they are added to the library.",
      form: {
        new: "New tool",
        edit: "Edit",
        archive: "Archive",
        reactivate: "Reactivate",
        create_title: "New tool",
        edit_title: "Edit tool",
        title: "Title",
        kind: "Type",
        kind_placeholder: "Choose a type",
        body: "Text",
        video_url: "Video link",
        file: "File (optional)",
        file_current:
          "Current file: %{name}. Uploading another one keeps the previous one.",
        file_hint: "PDF, PNG or JPEG, up to 10 MB.",
        stages: "Stages",
        projects: "Projects",
        buyer_types: "Client types",
        applies_to_all: "Applies to all",
        save: "Save",
        cancel: "Cancel",
        saved: "Tool saved",
        save_error: "Could not save. Try again.",
        errors: {
          title_required: "Enter a title.",
          kind_required: "Choose a type.",
          content_required: "Add a text, a link or a file.",
          video_url_invalid: "The link must start with http:// or https://.",
          file_not_allowed: "This kind of tool is text only and takes no file.",
          invalid_type: "The file must be a PDF, PNG or JPEG.",
          too_large: "The file is larger than the 10 MB limit.",
          upload_failed:
            "The file could not be uploaded and the tool was not saved. Check the file and try again.",
        },
      },
      kinds: {
        script: "Script",
        question: "Question",
        objection: "Objection answer",
        video: "Video",
        brochure: "Brochure",
        comparison: "Comparison",
        fact_sheet: "Fact sheet",
      },
    },
    // Almikia Epic EQ (TASK-018): payment plans admin and the lead's quoter.
    // Almikia Epic E6 (TASK-039): labels of the invoicing statuses and value sets
    // (the screens add their own keys under this namespace).
    invoicing: {
      status: {
        receivable: {
          pendiente_vobo: "Pending VoBo",
          por_facturar: "To invoice",
          facturada: "Invoiced",
          cobrada: "Collected",
          cancelada: "Cancelled",
        },
        payable: {
          pendiente_vobo: "Pending VoBo",
          por_pagar: "To pay",
          pagada: "Paid",
          cancelada: "Cancelled",
        },
      },
      payee_role: {
        asesora: "Advisor",
        vendedora: "Selling advisor",
        opcionadora: "Property provider",
        colega: "Colega",
      },
      payer_type: {
        developer: "Developer",
        client: "Buyer client",
      },
      basis: {
        bpo_scheme: "BPO scheme",
        colega_fixed: "Colega (fixed rate)",
        corretaje_split: "Brokerage split",
      },
      level: {
        entrenamiento: "Training",
        junior: "Junior",
        senior: "Senior",
        elite: "Elite",
        team_leader: "Team Leader",
      },
      // TASK-040: "Pending VoBo" and "Accounts receivable" screens.
      error: "The data could not be loaded. Please try again.",
      fields: {
        operation: "Operation",
        project: "Project",
        unit: "Unit",
        client: "Client",
        advisor: "Advisor",
        payer: "Payer",
        payee: "Payee",
        installment: "Installment",
        installment_n: "Installment %{n}",
        commission_pct: "Commission (%)",
        amount: "Amount (before VAT)",
        subtotal: "Subtotal",
        iva: "VAT (%{pct}%)",
        iva_amount: "VAT",
        total: "Total",
        status: "Status",
        sale_value: "Sale value",
        invoice_folio: "Invoice folio",
        collected_at: "Collection date",
        cancel_reason: "Cancellation reason",
        project_or_address: "Project or property",
        basis: "Scheme",
        level: "Level",
        rate: "Rate",
        accumulated_sales: "Accumulated sales",
      },
      vobo: {
        nav: "Pending VoBo",
        title: "Pending VoBo",
        subtitle: "Receivables and payables waiting for your approval.",
        tab_receivables: "Receivable",
        tab_payables: "Payable",
        empty_receivables: "No receivables are pending VoBo",
        empty_payables: "No payables are pending VoBo",
        last_rejection: "Last rejection reason: %{reason}",
        approve: "Approve",
        reject: "Reject",
        reject_receivable_title: "Reject receivable",
        reject_payable_title: "Reject payable",
        done: {
          approved: "VoBo approved",
          rejected: "Rejection recorded",
        },
      },
      approve: {
        title: "Approve receivable",
        description:
          "Review the data of operation %{operation}. Once approved, the concept is frozen.",
        concept_label: "Invoice concept",
        concept_hint:
          "Brokerage sales have no template: type the concept. You can use {N}, {PCT}, {UNIT}, {CLIENT}, {ADVISOR} and {PROJECT}.",
        preview: "Concept that will be frozen",
        confirm: "Approve VoBo",
        pct_source: {
          agreement:
            "The percentage comes from the project agreement (%{pct}%).",
          edited: "Percentage differs from the agreement, entered at VoBo.",
          entered: "Percentage entered at VoBo.",
        },
        errors: {
          installment: "Enter a valid installment number.",
          pct: "Enter a commission percentage between 0 and 100.",
          amount: "Enter an amount above zero with at most two decimals.",
          template: "The project has no concept template available.",
          concept: "Type the invoice concept.",
        },
      },
      receivables: {
        totals: "Totals by status",
        status_filter: "Filter by status",
        search: "Search by operation, project or client",
        invoice_title: "Mark as invoiced",
        invoice_description: "Enter the folio of the issued invoice.",
        invoice_folio: "Invoice folio",
        mark_invoiced: "Mark as invoiced",
        mark_collected: "Mark as collected",
        reject: "Reject",
        reject_title: "Reject receivable",
        reject_to: "The receivable returns to status: %{status}.",
        final_note:
          "A collected or paid account is corrected with an adjustment.",
        done: {
          invoiced: "Receivable marked as invoiced",
          collected: "Receivable marked as collected",
          rejected: "Rejection recorded",
        },
        concept_title: "Invoice concept",
        concept_pending:
          "The concept is frozen when Dirección approves the VoBo.",
        copy_concept: "Copy concept",
        copied: "Copied",
        concept_copied: "Concept copied",
        concept_copy_error: "The concept could not be copied",
      },
      // TASK-041: "Accounts payable" / "My payments".
      payables: {
        my_title: "My payments",
        advisor_invoice_notice:
          "Your payment is generated when you upload your own invoice. If Administration uploads it for you, the payment is not generated.",
        status_filter: "Filter by status",
        search: "Search by operation, payee or project",
        mark_paid: "Mark as paid",
        reject: "Reject",
        reject_title: "Reject payable",
        reject_to: "The payable goes back to: %{status}.",
        final_note:
          "A collected or paid account is corrected with an adjustment.",
        paid_title: "Mark as paid",
        paid_description:
          "Enter the payment date and, if you have it, the reference.",
        paid_on: "Payment date",
        reference: "Payment reference",
        receivable_info:
          "Linked receivable: %{status}. For information only, it does not block the payment.",
        done: {
          paid: "Payable marked as paid",
          rejected: "Rejection recorded",
        },
      },
    },
    // TASK-041: invoicing settings of a project (direccion).
    projects: {
      invoicing: {
        title: "Project invoicing",
        commission_label: "Developer commission (%)",
        commission_save: "Save commission",
        commission_hint:
          "Percentage proposed when approving the VoBo of a receivable.",
        commission_saved: "Commission updated",
        template_label: "Invoice concept template",
        template_save: "Save new version",
        template_saved: "Template updated",
        placeholders_help:
          "You can use these placeholders: %{placeholders}. They are replaced when the VoBo is approved.",
        frozen_warning:
          "Invoices already issued keep their text; the change applies to the next ones.",
        version_n: "version %{n}",
        history_title: "Version history",
      },
    },
    operations: {
      search: "Search by id or folio",
      error: "The action could not be completed",
      id_copied: "Id copied",
      open_lead: "Open lead",
      open_client: "Open client",
      client_registered: "Registered client",
      no_client: "No client linked",
      choose_advisor: "Choose an advisor",
      folio_preview: "Folio that will be generated:",
      expediente_guard: {
        title: "Buyers' files",
        loading: "Checking the files…",
        error: "We could not check the files. Try again.",
        retry: "Retry",
        no_contact:
          "Link the buyer contact to the lead before closing the operation",
        complete: "File complete",
        incomplete: "File incomplete",
        missing: "Missing:",
        open: "Open the file",
      },
      admin_title: "Administrative data",
      documents: {
        title: "Documents",
        loading: "Loading documents…",
        error: "The documents could not be loaded.",
        empty: "There are no documents in this operation yet.",
        empty_hint: "The file's documents will appear here once uploaded.",
        empty_hint_write: 'Use the "Upload document" button to add the first.',
        upload: "Upload document",
        upload_new_version: "Upload new version",
        upload_title: "Upload document",
        upload_hint:
          "It stays pending until an administration role validates it.",
        doc_type: "Document type",
        title_optional: "Title (optional)",
        file: "File",
        submit_upload: "Upload",
        uploaded: "Document uploaded",
        version: "Version %{number}",
        uploaded_by: "Uploaded by %{name} on %{date}",
        reviewed_by: "Reviewed by %{name} on %{date}",
        validated_by: "Ruled on by %{name} on %{date}",
        reason: "Reason",
        reason_required: "Enter the reason",
        download: "Download",
        download_error: "The download link could not be generated",
        review: "Review",
        validate: "Validate",
        observe: "Observe",
        reject: "Reject",
        delete: "Delete",
        confirm: "Confirm",
        cancel: "Cancel",
        observe_title: "Observe version",
        reject_title: "Reject version",
        delete_title: "Delete document",
        delete_hint:
          "The document is hidden but its history is kept. No file is erased.",
        review_done: "Version marked as reviewed",
        validate_done: "Version validated",
        observe_done: "Version observed",
        reject_done: "Version rejected",
        delete_done: "Document deleted",
        delete_retention_hint:
          "It cannot be deleted before its retention period ends (%{date})",
        action_error: "The action could not be completed",
        advisor_hint:
          "An administration role will validate your file; you cannot validate documents of your own operation.",
        payable_hint: {
          title: "Requirements to create the payable",
          green_file_yes: "Green file: yes",
          green_file_no: "Green file: no",
          invoice_yes: "Advisor invoice uploaded: yes",
          invoice_no: "Advisor invoice uploaded: no",
        },
        show_deleted: "Show deleted",
        hide_deleted: "Hide deleted",
        deleted: "Deleted",
        deleted_reason: "Deletion reason: %{reason}",
        types: {
          identificacion: "Identification",
          comprobante_domicilio: "Proof of address",
          constancia_fiscal: "Tax certificate",
          contrato: "Contract",
          apartado: "Reservation",
          pld: "AML",
          otro: "Other",
          factura_asesora: "Advisor invoice",
        },
        result: {
          pendiente: "Pending",
          validado: "Validated",
          observado: "Observed",
          rechazado: "Rejected",
        },
      },
      audit: {
        title: "History",
        loading: "Loading history…",
        error: "The history could not be loaded.",
        empty: "No changes recorded yet.",
        empty_hint:
          "Every change to this operation will be recorded here, with who made it and when.",
        load_more: "Show more entries",
        unknown_actor: "System",
        old_value: "before",
        new_value: "now",
        reason: "Reason: %{reason}",
        tables: {
          operations: "Operation",
          documents: "Document",
          document_versions: "Document version",
          units: "Unit",
          receivables: "Receivable",
          payables: "Payable",
        },
        actions: {
          insert: "Created",
          update: "Changed",
          delete: "Removed",
        },
        columns: {
          sale_value: "Sale value",
          commercial_status: "Commercial status",
          administrative_status: "Administrative status",
          semaphore: "Semaphore",
          sales_id: "Advisor",
          result: "Result",
          reviewed_at: "Reviewed on",
          validated_at: "Ruled on",
          deleted_at: "Deleted on",
          id: "Id",
          deal_id: "Deal",
          reservation_id: "Reservation",
          unit_id: "Unit",
          project_id: "Project",
          client_id: "Client",
          lead_type: "Lead type",
          operation_type: "Operation type",
          contract_folio: "Contract folio",
          signed_on: "Signed on",
          cancelled_at: "Cancelled on",
          cancelled_by: "Cancelled by",
          created_by: "Created by",
          created_at: "Created on",
          operation_id: "Operation",
          document_id: "Document",
          doc_type: "Document type",
          retention_until: "Keep until",
          deleted_by: "Deleted by",
          delete_reason: "Deletion reason",
          version_number: "Version number",
          mime_type: "File type",
          size_bytes: "Size (bytes)",
          sha256: "SHA-256 fingerprint",
          uploaded_by: "Uploaded by",
          uploaded_at: "Uploaded on",
          reviewed_by: "Reviewed by",
          validated_by: "Ruled on by",
          advisor_at_validation: "Advisor at ruling",
        },
      },
      history_title: "Advisor history",
      history_empty: "There are no advisor changes yet.",
      history_entry: "Assigned to %{advisor} by %{author}",
      lead_card_title: "Lead operations",
      filters: {
        project: "Project",
        commercial_status: "Commercial status",
        administrative_status: "Administrative status",
        semaphore: "Semaphore",
        advisor: "Advisor",
      },
      fields: {
        id: "Id",
        project: "Project",
        unit: "Unit",
        advisor: "Advisor",
        new_advisor: "New advisor",
        commercial_status: "Commercial status",
        administrative_status: "Administrative status",
        semaphore: "Semaphore",
        semaphore_reason: "Semaphore reason",
        operation_type: "Operation type",
        sale_value: "Sale value",
        folio: "Folio",
        signed_on: "Signature date",
        cancel_reason: "Cancellation reason",
        reason: "Reason",
        lead: "Lead",
        client: "Client",
        project_or_option: "Project / option",
      },
      commercial_status: {
        apartada: "Reserved",
        cerrada: "Closed",
        cancelada: "Cancelled",
      },
      administrative_status: {
        pendiente: "Pending",
        en_revision: "Under review",
        observado: "Flagged",
        validado: "Validated",
      },
      semaphore: {
        verde: "Green",
        amarillo: "Yellow",
        naranja: "Orange",
        rojo: "Red",
      },
      type: {
        propia: "Own",
        inter_bpo: "Inter BPO",
        intercorretaje: "Inter-brokerage",
        codigo_azul: "Blue Code",
      },
      actions: {
        sign: "Sign operation",
        sign_corretaje: "Close operation",
        cancel: "Cancel operation",
        change_advisor: "Change advisor",
        copy_id: "Copy id",
        save: "Save changes",
      },
      confirm: {
        back: "Back",
        accept: "Confirm",
        sign: {
          title: "Sign this operation?",
          description:
            "The signature date is saved and the folio is generated; it can no longer be changed. The unit becomes sold.",
        },
        cancel: {
          title: "Cancel this operation?",
          description:
            "The operation stays in the list as cancelled and the unit reservation is released. Give the reason.",
        },
        sign_corretaje: {
          title: "Close this operation?",
          description:
            "The closing date is saved and the option becomes sold. No contract folio is generated.",
        },
        cancel_corretaje: {
          title: "Cancel this operation?",
          description:
            "The operation stays in the list as cancelled and the option goes back to available. Give the reason.",
        },
        advisor: {
          title: "Change this operation's advisor?",
          description:
            "The new advisor will see the operation and the change is kept in the history with its reason.",
        },
      },
      done: {
        sign: "Operation signed",
        sign_corretaje: "Operation closed",
        cancel_corretaje: "Operation cancelled",
        cancel: "Operation cancelled",
        advisor: "Advisor changed",
        admin: "Data saved",
      },
    },
    quoter: {
      // Almikia batch EQ3 (TASK-114): approval of custom plans.
      approval: {
        pending: "Pending approval",
        approved: "Approved",
        rejected: "Rejected",
        pending_help:
          "This custom plan cannot be shared, printed or shown to the client until it is approved.",
        rejected_help:
          "This custom plan was rejected: %{comment}. Create another quote with a different plan.",
        list_title: "Plans to approve",
        empty: "There are no plans to approve.",
        approve: "Approve",
        reject: "Reject",
        reject_comment_label: "Reason for rejection",
        reject_comment_required: "Write the reason for the rejection",
        approved_toast: "Plan approved",
        rejected_toast: "Plan rejected",
        notice_requested:
          "A custom plan is waiting for approval (quote #%{id})",
        notice_approved: "Your custom plan was approved (quote #%{id})",
        notice_rejected:
          "Your custom plan was rejected (quote #%{id}): %{comment}",
        approvers_title: "Custom plan approver",
        approvers_help:
          "Only this person (and Direccion) can approve or reject a custom plan. When the person quoting is an approver, her plan is approved automatically.",
        approver_add: "Add approver",
        approver_active: "Active",
        approver_inactive: "Inactive",
        no_approver_warning:
          "There is no active approver: custom plans stay pending approval.",
        no_approver_title: "No active approver",
        custom_note:
          "A custom plan needs approval before it can be shared. If you are an approver, it is approved when you save.",
        created_pending: "Quote saved. The custom plan is pending approval.",
        created_approved: "Quote saved. The custom plan is approved.",
        list_error: "The plans to approve could not be loaded",
        requested_by: "Requested by: %{name}",
        client_unit: "%{client} · unit %{unit}",
        plan_summary:
          "Down payment %{down}% · Monthly %{monthly}% over %{months} months · Deed %{deed}% · Discount %{discount}%",
        age_today: "Today",
        age_days: "%{days} days ago",
        notices_to_approve: "You have %{count} custom plan(s) to approve",
        notices_open: "See plans to approve",
        notice_dismiss: "Got it",
        approver_pick: "Person",
        approver_pick_placeholder: "Choose a person",
        approver_activate: "Activate",
        approver_deactivate: "Deactivate",
        approver_none: "There are no approvers yet.",
        action_error: "The action could not be completed",
      },
      // Almikia Epic EQ (TASK-019): the public client quote page (Spanish by design).
      public: {
        brand: "Almikia",
        greeting: "Hola, %{name}",
        intro: "Esta es tu cotización.",
        price: "Precio",
        valid_until: "Vigente hasta el %{date}",
        save_pdf: "Guardar como PDF",
        unavailable:
          "Este enlace ya no esta disponible. Pide a tu asesora uno nuevo.",
        load_error: "No pudimos cargar la cotización. Intenta de nuevo.",
        // Epic EQ2 (TASK-101): the two-sheet public quote (Spanish by design).
        prepared_for: "Preparada especialmente para",
        plan_intro:
          "Tres formas de hacer suya esta residencia, al día y al peso.",
        share_whatsapp: "Enviar por WhatsApp",
        sheet: {
          folio: "Cotización #%{folio}",
          issued: "Emitida el %{date}",
          valid: "Vigencia: %{date}",
          page: "HOJA %{page} · 2",
          advisor: "Tu asesora",
          advisor_promise:
            "Te acompaño de esta cotización a la entrega de tu unidad.",
          whatsapp: "WhatsApp",
          qr_label: "Código QR para escribir por WhatsApp a tu asesora",
          qr_caption: "Escanee y hablamos",
          residence: "La residencia",
          model: "Modelo",
          program: "Programa",
          per_floor: "Por nivel",
          garage: "Cochera",
          construction: "Construcción total",
          unit: "La unidad",
          key: "Clave",
          block: "Manzana",
          stage: "Etapa",
          street: "Calle",
          surface: "Superficie",
          measures: "Medidas",
          excess_land: "Terreno excedente",
          orientation: "Orientación del frente",
          investment: "La inversión",
          list_price: "Precio de lista %{list}",
          excess_price: "Terreno excedente · %{m2}",
          roof: "Roof garden",
          roof_included: "Roof garden · incluido",
          extras: "Extras",
          discount: "Descuento %{scheme}",
          final_price: "Precio final",
          models: "Los modelos · lista %{list}",
          from: "Desde",
          scarcity:
            "Quedan %{in_stage} en su etapa · %{in_development} en el desarrollo",
          scarcity_development: "Quedan %{in_development} en el desarrollo",
          footer:
            "Precios en pesos mexicanos, sujetos a cambio al vencimiento de esta cotización o al cambio de lista de precios por avance de ventas, lo que ocurra primero. El apartado de %{apartado} se aplica al precio. Esta cotización no constituye un contrato.",
          plan_for: "Plan de pagos · %{name}",
          plan_note:
            "Todos los planes inician con un apartado de %{apartado} (se aplica al precio) y firma de contrato a más tardar el %{date}, fecha de vencimiento de esta cotización. La escrituración se realiza al concluir el plan de pagos.",
          includes_discount: "Incluye %{pct}% de descuento",
          list_price_only: "Precio de lista",
          date: "Fecha",
          total: "TOTAL",
        },
        wa: {
          qr_message:
            "Hola %{advisor}, le escribo por la cotización %{folio} de Almikia.",
          intro: "Hola %{name}, le comparto su cotización %{folio} de ALMIKIA:",
          unit: "• %{model} — Unidad %{unit}",
          unit_typed: "• %{model} — Unidad %{unit} (%{lotType})",
          construction: "%{m2} m² de construcción",
          surface: "lote de %{m2} m²",
          roof: "• Con roof garden",
          price: "• Precio: %{price} — %{scheme}",
          valid: "• Vigencia: %{date}",
          closing: "Quedo a sus órdenes.",
        },
      },
      title: "Quoter",
      empty: "This lead has no quotes yet.",
      empty_hint: "This lead's quotes will appear here.",
      empty_hint_write: "Create the first one with the form below.",
      error: "Could not load the quotes. Try again.",
      action_error: "The action could not be completed. Try again.",
      new_quote: "New quote",
      project: "Project",
      pick_project: "Pick a project to see its units.",
      unit: "Unit",
      units_error: "Could not load the units. Try again.",
      units_empty: "This project has no units.",
      more_units: "Show more units",
      no_price: "No list price",
      plan: "Payment plan",
      plan_placeholder: "Pick a plan",
      plans_empty: "This project has no active payment plans.",
      client_first_name: "Client first name",
      client_label: "Client: %{name}",
      save_quote: "Save quote",
      show_schedule: "Show payment schedule",
      link_until: "Link valid until %{date}",
      link_revoked: "Link revoked",
      link_none: "No share link",
      link_copied: "Link copied",
      link_revoked_done: "Link revoked",
      reserve: "Reserve unit",
      release: "Release reservation",
      cancel_quote: "Cancel quote",
      copy_link: "Copy link",
      revoke_link: "Revoke link",
      reserve_blocked_compliance:
        "Cannot reserve: the project's compliance pack is pending.",
      confirm: {
        reserve: "Reserve unit %{unit}?",
        release: "Release the reservation of unit %{unit}?",
        release_warning:
          "If an operation is open for this reservation, it will be cancelled.",
        cancel: "Cancel this quote? It stays in the list.",
        sell: "Sell unit %{unit}?",
        sell_warning:
          "The unit is marked as sold and the other quotes of this unit are cancelled.",
        back: "Back",
        accept: "Confirm",
      },
      builder: {
        scheme: "Payment scheme",
        scheme_placeholder: "Pick a scheme",
        schemes_empty: "This project has no active payment schemes.",
        custom: "Custom plan",
        custom_down: "Down payment (%)",
        custom_monthly: "Monthly payments (%)",
        custom_deed: "On deed (%)",
        custom_months: "Months",
        custom_discount: "Discount (%)",
        roof_add: "Add roof (%{price})",
        roof_line: "Roof",
        included: "Included",
        unit_filter: "Search unit",
        unit_filter_empty: "No unit matches the search.",
        units_none: "This project has no units.",
        no_model: "No model",
        stage: "Stage %{stage}",
        blocked: "Blocked",
        unavailable: "Unavailable",
        unverified: "To be verified",
        unverified_warning:
          "This unit is to be verified: Direccion has not yet confirmed its availability or price. You can quote it, but tell the client.",
        preview_title: "Preview",
        preview_pick: "Pick a unit and a scheme to see the price.",
        preview_error: "The quote could not be calculated. Try again.",
        list: "List %{list}",
        base: "Base price",
        excess: "Excess (%{m2} m²)",
        extras: "Extras",
        gross: "List price",
        discount: "Discount (%{pct}%)",
        final: "Final price",
        apartado: "Reservation",
        down: "Down payment on signing",
        installments: "%{count} monthly payments of",
        deed: "On deed (month %{month})",
        valid_until: "Valid until %{date}",
        scarcity_stage:
          "%{stage} left in its stage / %{total} in the development",
        scarcity_development: "%{total} left in the development",
        calendar: "Payment calendar",
        models_title: "Models at the current list",
        from: "From %{price}",
        state_valid: "Valid",
        state_expired: "Expired",
        expired_hint:
          "This quote has expired. Reissue it at the current list price to reserve or sell.",
        sell: "Sell",
        reissue: "Reissue",
        reissued_up: "Reissued on list %{list}: the price went up %{amount}.",
        reissued_down:
          "Reissued on list %{list}: the price went down %{amount}.",
        reissued_same: "Reissued on list %{list}: the price did not change.",
        sold_done: "Unit sold",
      },
      quote_status: {
        activa: "Active",
        cancelada: "Cancelled",
        convertida: "Converted to sale",
      },
      unit_status: {
        disponible: "Available",
        apartada: "Reserved",
        vendida: "Sold",
      },
      unit_types: { depto: "Apartment", local: "Commercial unit", lote: "Lot" },
      schedule: {
        title: "Payment schedule",
        concept: "Concept",
        when: "When",
        amount: "Amount",
        at_signing: "At signing",
        at_end: "On delivery",
        month: "Month %{month}",
      },
      concepts: {
        enganche: "Down payment",
        mensualidad: "Monthly payment",
        diferido: "Deferred payment",
        entrega: "Payment on delivery",
        credito: "Credit",
      },
      planTypes: {
        enganche_mensualidades: "Down payment and monthly payments",
        diferido: "Deferred",
        contra_entrega: "On delivery",
        credito: "Credit",
      },
      templates: {
        nav: "Payment plans",
        title: "Payment plans",
        new: "New template",
        intro:
          "Payment plan templates per project. Advisors use them to quote; nothing is deleted, only archived.",
        show_archived: "Show archived",
        error: "Could not load the plans. Try again.",
        empty: "No payment plans to show.",
        archived: "Archived",
        edit: "Edit",
        archive: "Archive",
        reactivate: "Reactivate",
      },
      templateForm: {
        create_title: "New plan template",
        edit_title: "Edit plan template",
        project: "Project",
        project_placeholder: "Pick a project",
        name: "Name",
        plan_type: "Plan type",
        plan_type_placeholder: "Pick a type",
        percentages: "Percentages and number of payments",
        fields: {
          down_payment_pct: "Down payment (%)",
          down_payment_count: "Down payment installments",
          monthly_payments_pct: "Monthly payments (%)",
          monthly_payments_count: "Number of monthly payments",
          deferred_payments_pct: "Deferred payments (%)",
          deferred_payments_count: "Number of deferred payments",
          delivery_pct: "On delivery (%)",
          credit_pct: "Credit (%)",
          discount_pct: "Discount (%, optional)",
        },
        errors: {
          project_required: "Pick a project.",
          name_required: "Enter a name.",
          plan_type_required: "Pick a plan type.",
          pct_invalid: "Enter a percentage between 0 and 100.",
          count_invalid: "Enter a whole number, 0 or more.",
          count_required: "Enter at least one payment for this percentage.",
          sum_not_100: "The percentages must add up to 100.",
        },
        preview: "Preview for %{amount} MXN",
        preview_empty: "Complete the plan to see the preview.",
        cancel: "Cancel",
        save: "Save",
        saved: "Plan saved",
        save_error: "Could not save. Try again.",
      },
      // Almikia Epic EQ2 (TASK-099): Direccion configuration screens.
      config: {
        nav: "Quoter",
        title: "Quoter configuration",
        project: "Project",
        sections: "Configuration sections",
        section_config: "Configuration",
        section_lists: "Price lists",
        section_catalogue: "Models and schemes",
        section_verify: "Verify units",
        config_intro: "These values apply to every new quote of the project.",
        fields: {
          apartado_amount: "Reservation amount ($)",
          apartado_days: "Reservation days",
          quote_validity_days: "Quote validity (days)",
          term_months: "Installments term (months)",
          excess_price_per_m2: "Excess price per m² ($)",
          client_protection_days: "Client protection (days)",
          released_stages: "Released stages (comma separated)",
          apartados_count_toward_list: "Reservations count toward the list",
        },
        save: "Save",
        saved: "Changes saved",
        save_error: "Could not save. Try again.",
        cancel: "Cancel",
        edit: "Edit",
        archive: "Archive",
        reactivate: "Reactivate",
        archived: "Archived",
        load_error: "We could not load the configuration. Try again.",
        no_projects: "No project has a quoter yet.",
        no_projects_hint:
          "Once a project has its quoter configuration it will show up here.",
        errors: {
          amount_invalid: "Enter an amount of 0 or more.",
          days_invalid: "Enter a whole number of days, 0 or more.",
          term_invalid: "Enter a whole term between 1 and 36 months.",
          stages_invalid:
            "Enter whole stage numbers separated by commas, for example 1, 2.",
          block_invalid: "Enter a whole number of sales, 1 or more.",
          pct_invalid: "Enter a percentage between 0 and 100.",
          price_invalid: "Enter a price above 0.",
          captured_locked: "A captured price can be changed but not removed.",
          code_invalid: "Enter a code with letters, numbers or dashes.",
          name_required: "Enter a name.",
          sum_not_100:
            "Down payment, monthly payments and deed must add up to 100%.",
          discount_invalid: "Enter a discount from 0 to 99.",
        },
      },
      lists: {
        title: "Price lists",
        intro:
          "Each list has its own sales block and an increment over the previous list, or a captured price per model. A captured price wins over the increment.",
        add: "Add list",
        empty: "This project has no price lists yet.",
        list_n: "List %{n}",
        reached_with: "Reached with %{sales} sales",
        block_size: "Sales in this block",
        increment_pct: "Increment over the previous list (%)",
        captured: "Captured price per model (optional)",
        captured_hint:
          "Leave empty to use the increment. A captured price can be changed but not removed.",
        save_list: "Save list %{n}",
        preview: "Price preview per model (read only)",
        model: "Model",
      },
      models: {
        title: "Models",
        new: "New model",
        new_title: "New model",
        edit_title: "Edit model",
        fields: {
          code: "Code",
          name: "Name",
          base_price: "Base price ($)",
          roof_price: "Roof garden price ($)",
          m2_per_floor: "m² per floor (optional)",
          total_construction: "Total construction in m² (optional)",
          program: "Program (optional)",
          garage: "Garage (optional)",
        },
      },
      schemes: {
        title: "Payment schemes",
        new: "New scheme",
        new_title: "New payment scheme",
        edit_title: "Edit payment scheme",
        summary:
          "Down payment %{down}% · Monthly %{monthly}% · Deed %{deed}% · Discount %{discount}%",
        fields: {
          name: "Name",
          down_pct: "Down payment (%)",
          monthly_pct: "Monthly payments (%)",
          deed_pct: "Deed (%)",
          discount_pct: "Discount (%)",
        },
      },
      impact: {
        title: "Review the term change",
        question:
          "The term goes from %{current} to %{next} months. Review what would happen before confirming.",
        valid_quotes: "Valid quotes",
        changed_quotes: "Quotes that change",
        total_before: "Installments before",
        total_after: "Installments after",
        total_delta: "Total difference",
        per_quote: "Difference per quote",
        none: "No valid quote changes. Only the term is updated.",
        note: "Prices do not change: only the installment plan of those quotes.",
        error: "We could not calculate the impact. Try again.",
        apply_error: "The change could not be applied. Nothing was modified.",
        cancel: "Cancel and change nothing",
        confirm: "Confirm and recalculate",
      },
      verify: {
        title: "Verify units",
        intro:
          "Units pending verification can be quoted, but the quoter warns. Confirm them one by one or several at once.",
        view_pending: "To verify",
        view_verified: "Verified",
        bulk: "Verify selected (%{count})",
        select_all: "Select all (%{count})",
        clear: "Clear selection",
        select_unit: "Select unit %{unit}",
        confirm_unit: "Confirm unit %{unit}",
        confirm: "Confirm",
        done: "Units verified",
        error: "Could not verify. Try again.",
        load_error: "We could not load the units. Try again.",
        empty_pending: "No units to verify.",
        empty_pending_hint: "Every unit of this project is confirmed.",
        empty_verified: "No verified units yet.",
        empty_verified_hint:
          "Units you confirm will show up here with who and when.",
        stage: "Stage %{stage}",
        no_stage: "No stage",
        blocked: "Blocked",
        not_blocked: "Not blocked",
        verified_by_at: "Verified by %{name} on %{when}",
        unknown_person: "a team member",
        prev: "Previous",
        next: "Next",
        page_of: "Page %{page} of %{pages}",
      },
      panel: {
        nav: "Quoter panel",
        title: "Quoter panel",
        load_error: "We could not load the panel. Try again.",
        no_config: "This project has no quoter configuration.",
        no_config_hint: 'Set it up in "Quoter configuration".',
        current_list: "Current list",
        missing_for_list: "Sales missing for list %{list}",
        missing_last: "You are on the last list",
        available_units: "Available units",
        counted_with_apartados:
          "Sales and reservations counting toward the list: %{count}",
        counted_sold_only: "Sales counting toward the list: %{count}",
        scarcity: "Availability by stage",
        scarcity_empty: "There are no available units.",
        available_count: "%{count} available",
        released: "Released",
        not_released: "Not released",
        models: "Models on the current list",
        price_from: "From %{price}",
        audit_title: "Configuration changes",
        audit_error: "We could not load the changes. Try again.",
        audit_empty: "No configuration changes recorded yet.",
        audit_unknown_actor: "Someone on the team",
        audit_action_insert: "Added to %{table}",
        audit_action_update: "Changed in %{table}",
        audit_action_delete: "Removed from %{table}",
        audit_tables: {
          quoter_configs: "the configuration",
          quoter_models: "the models",
          quoter_price_lists: "the price lists",
          quoter_model_list_prices: "the captured prices",
          quoter_schemes: "the payment schemes",
          quoter_unit_details: "the unit data",
        },
      },
    },
    assignmentLog: {
      nav: "Assignment log",
      title: "Assignment log",
      intro:
        "Who received each lead, when, through which channel and by which method. Newest first.",
      filter_project: "Project",
      filter_channel: "Channel",
      filter_from: "From day",
      filter_to: "To day",
      all: "All",
      empty: "There are no assignments to show.",
      empty_hint:
        "Every time a lead is assigned to an advisor it is recorded here. Try another date range or clear the filters.",
      lead: "Lead",
      unassigned: "No advisor available",
      received_by: "Received by: %{name}",
      clave: "Code: %{code}",
      previous_clave: "Previous advisor code: %{code}",
      channel_value: "Channel: %{channel}",
      previous: "Previous",
      next: "Next",
      method: {
        rotation: "Rotation",
        fallback_rotation: "Rotation (no available block)",
        manual: "Manual",
      },
    },
    autoAssign: {
      button: "Assign automatically",
      assigned: "Lead assigned to %{name}.",
      nobody: "Nobody was available right now. The lead still has no advisor.",
      error: "Could not assign the lead. Please try again.",
    },
    // Almikia Epic EL3: documented reassignment; a written reason is mandatory.
    reassign: {
      direccion_button: "Reassign (Direction)",
      notice_button: "Reassign",
      title: "Reassign lead",
      advisor_label: "Advisor",
      advisor_placeholder: "Choose an advisor",
      reason_label: "Reason for the reassignment",
      reason_required: "Write the reason for the reassignment",
      submit: "Reassign",
      cancel: "Cancel",
      success: "Lead reassigned to %{name}.",
      error: "Could not reassign the lead. Please try again.",
      permission_title: "Protected lead reassignment",
      permission_label: "Can reassign proactive and colleague leads",
      permission_help:
        "Only Direction changes this permission, and never on its own profile.",
      permission_on: "Permission granted.",
      permission_off: "Permission removed.",
      permission_error: "Could not change the permission. Please try again.",
    },
    // Almikia Epic EL (TASK-008): Direccion "Lead assignment" screen.
    leadAssignment: {
      nav: "Lead assignment",
      title: "Lead assignment",
      intro:
        "Decide in which projects new leads are shared out automatically among the participating advisors.",
      project_label: "Project",
      no_projects: "There are no active projects yet.",
      rule_label: "Assign leads automatically",
      rule_help:
        "When off, new leads of this project stay unassigned for the Lead Manager.",
      fallback_label: "If nobody is available, rotate among the advisors",
      fallback_help:
        "When off, the lead stays unassigned for the Lead Manager if nobody is available at that moment.",
      advisors_title: "Participating advisors",
      advisors_help:
        "Only advisors with an active membership in the project appear. Switch who receives leads on or off.",
      advisors_empty: "This project has no active advisors.",
      clave: "Code %{code}",
      advisor_toggle: "Include %{name} in the rotation",
      unavailable: "Not available to receive leads",
      blocks_chosen: "Has chosen blocks",
      blocks_none: "Has not chosen blocks yet",
      channels_title: "Channels",
      channels_help:
        "Channels are the ways leads arrive. You can activate, deactivate or add channels.",
      channel_active: "Active",
      channel_inactive: "Inactive",
      channel_toggle: "Channel %{label} active",
      meta_note: "Activated when the Meta integration is connected",
      add_channel_title: "Add a channel",
      channel_label: "Channel name",
      channel_code: "Channel code",
      add_channel: "Add channel",
      channel_error_label_required: "Enter the channel name.",
      channel_error_code_required: "Enter a code with letters or numbers.",
      channel_error_duplicate: "A channel with that code already exists.",
      saved: "Changes saved",
      save_error: "Could not save. Try again.",
    },
    aiUsage: {
      nav: "AI usage",
      title: "AI usage",
      spend_label: "Estimated spend this month",
      spend_of_cap: "%{spent} of %{cap}",
      remaining: "%{remaining} left this month",
      estimate_note:
        "Cost is an estimate based on the tokens used and the configured prices.",
      cap_reached:
        "The monthly limit has been reached: new AI requests are paused until next month or until you raise the limit.",
      cap_label: "Monthly limit (USD)",
      cap_invalid: "Enter a number greater than zero.",
      cap_saved: "Monthly limit saved",
      cap_error: "Could not save the limit. Try again.",
      per_action_title: "This month by action",
      history_title: "History by month",
      history_row:
        "%{cost} · %{calls} call · %{tokens} tokens |||| %{cost} · %{calls} calls · %{tokens} tokens",
      calls_tokens:
        "%{calls} call · %{tokens} tokens |||| %{calls} calls · %{tokens} tokens",
      recent_title: "Latest calls",
      no_usage: "No AI usage yet.",
      no_usage_hint:
        "Copilot calls and their cost will appear here as soon as someone uses it.",
      actions: {
        note_suggestions: "Note suggestions",
        suggest_message: "Suggest message",
        whats_missing: "What am I missing?",
      },
      statuses: {
        ok: "OK",
        rejected_cap: "Rejected by limit",
        error: "Error",
      },
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      complete_unmatched_sources:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors. %{smart_count} source did not match an active source and was kept as text only |||| Import complete. Imported %{importCount} records, with %{errorCount} errors. %{smart_count} sources did not match an active source and were kept as text only",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    feedback: {
      button: "Report a problem or suggestion",
      title: "Report a problem or suggestion",
      description:
        "Tell us what happened or what you would improve. Your comment goes to Dirección.",
      kind_label: "Type",
      kind_problema: "Problem",
      kind_sugerencia: "Suggestion",
      message_label: "Message",
      message_placeholder: "Describe the problem or your suggestion",
      screen: "Screen: %{title}",
      send: "Send",
      sending: "Sending...",
      cancel: "Cancel",
      success: "Thanks, your comment reached Dirección",
      error_empty: "Write a message before sending.",
      error_too_long: "The message cannot exceed %{max} characters.",
      error_generic: "We could not send your comment. Please try again.",
      screen_dashboard: "Home",
      screen_unknown: "Application screen",
      screen_detail: "%{name} details",
      screen_create: "New: %{name}",
      screen_operation: "Operation %{code}",
    },
    pilotReports: {
      nav: "Pilot reports",
      title: "Pilot reports",
      new_badge: "%{smart_count} new |||| %{smart_count} new",
      status_filter: "Filter by status",
      kind_filter: "Filter by type",
      status_nuevo: "New",
      status_revisado: "Reviewed",
      status_resuelto: "Resolved",
      empty: "No reports",
      reviewed_by: "Reviewed by %{name} on %{date}",
      note_label: "Dirección note",
      save_note: "Save note",
      mark_revisado: "Mark Reviewed",
      mark_resuelto: "Mark Resolved",
      status_saved: "Report updated",
      note_saved: "Note saved",
      update_error: "We could not update the report. Please try again.",
      previous: "Previous",
      next: "Next",
    },
    inventory_stats: {
      captures_title: "Your captures this month",
      captures_progress: "%{actual} of %{target} captures",
      captures_so_far:
        "%{smart_count} capture this month |||| %{smart_count} captures this month",
      captures_bar_label: "Captures progress against your goal",
      average_title: "Average days in stock",
      average_value: "%{smart_count} day |||| %{smart_count} days",
      average_empty: "No available properties",
      truncated: "Too many properties to show a complete figure",
    },
    goals: {
      title: "Goals",
      month_label: "Month",
      section_advisor: "Advisor goals",
      section_team: "Líder BPO team goals",
      no_goal: "No goal set",
      empty_title: "There is no one to set a goal for yet",
      empty_description: "No advisor or Líder BPO is within your scope yet.",
      fields: {
        target_units: "Unit target",
        target_amount_mxn: "Amount target (MXN)",
        target_captures: "Captures per month",
      },
      captured_this_month:
        "%{smart_count} captured this month |||| %{smart_count} captured this month",
      action: {
        save: "Save",
      },
      save_success: "Goal saved",
      error: {
        invalid_target: "Enter a whole number of 0 or more",
        save_denied: "You don't have permission to save this goal.",
        save_failed: "Could not save the goal. Please try again.",
      },
    },
    my_progress: {
      title: "My progress",
      month_bar_summary:
        "%{smart_count} day left |||| %{smart_count} days left",
      goal_title: "Your goal for the month",
      no_goal: "No goal set for this month",
      units_and_amount: "%{units} direct sales · %{amount}",
      units_label: "Units",
      units_progress: "%{actual} of %{target} units",
      units_bar_label: "Units progress against your goal",
      amount_label: "Amount (MXN)",
      amount_progress: "%{actual} of %{target}",
      amount_bar_label: "Amount progress against your goal",
      empty_title: "You have no activity yet this month",
      empty_description:
        "As soon as you register a direct sale, your progress shows up here.",
      explanation:
        "Every month and every quarter start from zero: nothing carries over from the previous period, and only your direct sales count (your colleagues' don't).",
      program: {
        monthly_sale_incentive: {
          title: "Monthly sale incentive",
          sales_count:
            "%{smart_count} direct sale this month |||| %{smart_count} direct sales this month",
        },
        quarterly_outstanding_sales: {
          title: "Quarterly outstanding sales",
          tier_reached: "Tier reached: %{rate}% commission",
          missing: "You're %{units} units / %{amount} short",
          bar_label: "Quarterly outstanding sales progress",
        },
        monthly_proactive_appointments: {
          title: "Monthly proactive appointments",
          count: "%{count} of %{target} appointments",
          bar_label: "Proactive appointments progress",
        },
        gasoline_insurance: {
          title: "Gasoline insurance",
          empty: "No gasoline insurance information yet.",
        },
      },
    },
    // Almikia Epic E7 (TASK-095): "Incentivos" admin form validation errors,
    // see `incentiveProgramForm.ts`.
    incentives: {
      error: {
        negative_number: "Enter a number of 0 or more",
        valid_to_before_valid_from:
          "The end date cannot be earlier than the start date",
        tiers_not_ascending: "Tiers must be in ascending order by threshold",
        tier_inclusive_required:
          "Choose whether the tier's threshold is inclusive",
        new_valid_from_too_early:
          "The new validity period must start after the current one",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
        stages_locked: "These states are fixed and cannot be edited here.",
        stages_manage_link: "Go to Stages",
        stages_readonly_note:
          "Direccion configures the stages and their criteria.",
        activities_manage_link: "Go to Activities",
        profile_options_manage_link: "Go to Profile options",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
        admin: "Administration",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    leadSources: {
      page_title: "Lead sources",
      manage_link: "Go to Lead sources",
      add_action: "New source",
      edit_action: "Edit",
      deactivate_action: "Deactivate",
      reactivate_action: "Reactivate",
      inactive_marker: "Inactive",
      empty: "There are no lead sources yet.",
      empty_description:
        "Sources say where each lead comes from, for example ads or referrals.",
      created_notice: "Source created",
      updated_notice: "Source updated",
      deactivated_notice: "Source deactivated",
      reactivated_notice: "Source reactivated",
      confirm_deactivate_title: "Deactivate this source?",
      confirm_deactivate_body:
        "The source is no longer offered on new leads. Leads that already have it keep it.",
      confirm_reactivate_title: "Reactivate this source?",
      confirm_reactivate_body: "The source is available again for new leads.",
    },
    // Almikia Epic E9 (TASK-049): "Meta leads" (direccion only).
    metaLeads: {
      title: "Meta leads",
      manage_link: "Go to Meta leads",
      back: "Back to Settings",
      intro:
        "Webhooks received from Meta Lead Ads and what happened with each lead. Newest first.",
      status_title: "Received webhooks",
      filter_result: "Result",
      all: "All",
      empty: "No webhooks received yet.",
      empty_hint:
        "When Meta sends a new lead you will see here what happened to it.",
      lead: "Lead",
      unclassified: "Unclassified",
      previous: "Previous",
      next: "Next",
      result: {
        received: "Received",
        rejected_signature: "Rejected: invalid signature",
        processed: "Processed",
        ignored: "Ignored",
        error: "Error",
      },
      signature: { valid: "Valid signature", invalid: "Invalid signature" },
      project_choice: {
        form_mapping: "Project from the form",
        none: "No project",
        not_sellable: "Project not sellable",
      },
      assignment: {
        assigned: "Assigned",
        no_candidates: "No candidates: left for the Lead Manager",
        skipped: "Not assigned",
        rule_disabled: "Assignment disabled",
      },
      mapping: {
        title: "Meta forms and projects",
        intro:
          "Each Meta form id sends its leads to a project. Only sellable projects are offered.",
        empty: "No forms mapped yet.",
        add_action: "Add form",
        change_action: "Change project",
        choose_project: "Choose a project",
        created_notice: "Form added",
        updated_notice: "Project updated",
      },
      mapping_format_help:
        "One token per line: form:<id>, campaign:<id> or ad:<id>. When several sources match, the ad wins, then the campaign, then the form.",
    },
    // Almikia Epic EM (TASK-067): Meta origin of a lead, campaign report and Meta events.
    metaOrigin: {
      title: "Meta origin",
      no_origin: "No Meta origin",
      platform: { facebook: "Facebook", instagram: "Instagram" },
      lookup_status: {
        pendiente: "Pending lookup",
        ok: "Looked up",
        sin_anuncio: "No ad",
      },
      fields: {
        campaign: "Campaign",
        adset: "Ad set",
        ad: "Ad",
        ad_title: "Ad title",
        platform: "Platform",
        ctwa_clid: "ctwa_clid",
        first_contact_at: "First contact",
        lookup_status: "Ad lookup",
      },
      lookup_action: "Look up ad",
      lookup_pending_action: "Look up pending",
      lookup_done: "Ad looked up",
      ctwa_save_action: "Save ctwa_clid",
      ctwa_saved: "ctwa_clid saved",
      retry_action: "Retry lookup",
      lookup_failed: "The ad could not be looked up. Please try again later.",
      load_error: "The Meta origin could not be loaded",
      ids_summary: "Identifiers",
      ids: {
        ad_id: "Ad ID",
        campaign_id: "Campaign ID",
        adset_id: "Ad set ID",
        leadgen_id: "Form ID (leadgen)",
      },
      ctwa_input_label: "Enter ctwa_clid by hand",
      ctwa_required: "Enter the ctwa_clid",
      ctwa_too_long: "The ctwa_clid is too long",
      ctwa_invalid:
        "The ctwa_clid only allows letters, numbers, hyphens and underscores",
      ctwa_unchanged: "That ctwa_clid was already recorded",
      ctwa_failed: "The ctwa_clid could not be saved",
      report: {
        title: "Meta campaign report",
        export_action: "Export CSV",
        empty: "There are no Meta leads in this date range.",
        export_denied: "Your role cannot export this report",
        nav: "Campaign reports",
        error: "The report could not be loaded",
        platform_filter: "Platform",
        platform_all: "All",
        range_from: "From",
        range_to: "To",
        group_by: "Group by",
        group: { campaign: "Campaign", adset: "Ad set", ad: "Ad" },
        headers: {
          campaign: "Campaign",
          adset: "Ad set",
          ad: "Ad",
          platform: "Platform",
          leads: "Leads",
          qualified_leads: "Qualified leads",
          appointments: "Appointments",
          reservations: "Reservations",
          sales: "Sales",
          sale_value: "Sales value",
          qualified_rate: "Qualified %",
          appointment_rate: "Appointment %",
          sales_rate: "Sales %",
          median_first_response: "First response (median, min)",
        },
      },
      events: {
        title: "Meta events",
        empty: "There are no events for these filters.",
        retry_action: "Retry",
        retry_done: "Event queued for retry",
        process_pending_action: "Process pending",
        process_pending_done: "Pending events processed",
        process_pending_result: "Events sent: %{count}",
        manage_link: "Go to Meta events",
        filter_all: "All",
        load_error: "Could not load the events",
        action_error: "The action could not be completed. Please try again.",
        config_missing_title: "Missing configuration",
        config_missing_body:
          "The last send attempt reported that the Meta integration is not configured. Events stay pending until the owner completes it.",
        log: {
          show: "View attempts",
          hide: "Hide attempts",
          empty: "This event has no attempts yet.",
          error: "Could not load the attempt log",
          attempt: "Attempt %{number}",
          http_status: "HTTP status",
          response: "Response",
          error_label: "Error",
        },
        filter_status: "Status",
        filter_event: "Event",
        filter_from: "From",
        filter_to: "To",
        headers: {
          lead: "Lead",
          event: "Event",
          status: "Status",
          attempts: "Attempts",
          event_time: "Event date",
          last_attempt: "Last attempt",
          next_attempt: "Next attempt",
          last_error: "Last error",
          value: "Value",
        },
        name: {
          lead_calificado: "Qualified lead",
          cita: "Appointment",
          compra: "Purchase",
        },
        status: {
          pending: "Pending",
          sent: "Sent",
          failed: "Failed",
          abandoned: "Abandoned",
        },
        log_status: {
          sent: "Sent",
          failed: "Failed",
          abandoned: "Abandoned",
          sin_configuracion: "Not configured",
          reintento: "Retry",
        },
      },
    },
    // Almikia Epic EC (TASK-030) / EC2d (TASK-137): "Inventario Almikia" (options, exclusives and BPO units).
    opciones: {
      search: "Search by address",
      filters: {
        status: "Status",
        zone: "Zone",
        type: "Type",
        responsable: "Responsible",
        panel: "Filters",
        clear: "Clear filters",
        origin: "Origin",
        operation: "Operation",
        furnished: "Furnished",
        price_min: "Minimum price",
        price_max: "Maximum price",
        area_min: "Minimum m²",
        area_max: "Maximum m²",
        levels_min: "Levels (minimum)",
        bedrooms_min: "Bedrooms (minimum)",
        bathrooms_min: "Bathrooms (minimum)",
        parking_min: "Parking (minimum)",
      },
      origin: {
        opcion: "Option",
        exclusiva: "Exclusive",
        bpo: "BPO",
      },
      operation: {
        venta: "Sale",
        renta: "Rental",
      },
      furnished: {
        amueblado: "Furnished",
        sin_amueblar: "Unfurnished",
      },
      specs: {
        levels: "%{value} lvl.",
        bedrooms: "%{value} bed.",
        bathrooms: "%{value} bath.",
        area_m2: "%{value} m²",
        parking: "%{value} park.",
      },
      choose_furnished: "Choose furnished or not",
      status: {
        disponible: "Available",
        apartada: "Reserved",
        vendida: "Sold",
        retirada: "Withdrawn",
      },
      type: {
        casa: "House",
        departamento: "Apartment",
        terreno: "Land",
        local: "Commercial unit",
        oficina: "Office",
        rancho: "Ranch",
        bodega: "Warehouse",
        lote_habitacional: "Residential lot",
        lote_comercial: "Commercial lot",
        lote_industrial: "Industrial lot",
        otro: "Other",
      },
      actions: {
        disponible: "Mark available",
        apartada: "Mark reserved",
        vendida: "Mark sold",
        retirada: "Withdraw",
      },
      edit_action: "Edit",
      create_title: "New Inventario Almikia property",
      edit_title: "Edit Inventario Almikia property",
      choose_type: "Choose the type",
      choose_responsable: "Choose who is responsible",
      owner_title: "Owner contact",
      owner_form_hint:
        "Only Direccion, the coordinator and the option's responsible advisor see it.",
      owner_private: "The owner's data is private.",
      owner_empty: "No owner contact has been registered yet.",
      created_notice: "Property registered",
      updated_notice: "Property updated",
      status_changed_notice: "Property status updated",
      // Almikia Epic EC2d (TASK-138): promotion checklist of a property.
      promotion: {
        title: "Promotion",
        lona_placed: "Banner placed",
        lona_kind: "Banner type",
        se_vende: "For sale",
        se_renta: "For rent",
        photos_professional: "Professional photos",
        video: "Video",
        virtual_tour: "Virtual tour",
        published_portals: "Published on portals",
        portals: "Portals",
        portals_required: "Pick at least one portal",
        published_social: "Published on social networks",
        ficha_ready: "Fact sheet ready",
        saved: "Saved",
        yes: "Yes",
        no: "No",
      },
    },
    // Almikia Epic EC2d (TASK-138): Direccion-only property types catalogue admin.
    propertyTypes: {
      page_title: "Property types",
      list_title: "Types catalogue",
      manage_link: "Go to Property types",
    },
    // Almikia Epic EC (TASK-032): corretaje sale administration, split and Direccion VoBo.
    corretaje: {
      fields: {
        option: "Option",
      },
      sale: {
        title: "Sale administration",
        choose: "Choose an option",
        yes: "Yes",
        no: "No",
        shared: "Sale shared with a colleague?",
        found_by: "Who found the colleague?",
        found_by_options: {
          asesora_proactiva: "The advisor (proactively)",
          lead_manager: "Assigned by the Lead Manager",
          direccion_corretaje: "Assigned by the Brokerage Director",
        },
        property_owner: "Whose property is it?",
        property_owner_options: {
          almikia: "Our inventory",
          colega: "The colleague's",
        },
        opcionadora: "Property provider",
        opcionadora_vendedora: "%{name} (the seller)",
        vendedora: "Seller",
        commission_total: "Total commission",
        save: "Save administration",
        saved: "Sale administration saved",
        error: "The sale administration could not be loaded",
        locked_note:
          "The sale has the Direccion VoBo and can no longer be edited.",
        read_only_note:
          "You can only view this sale. Administration, Direccion and the coordination edit it.",
        split_title: "Commission split",
        case: "Case %{code}",
        split_empty: "Enter the total commission to see the split.",
        split_unavailable: "The split is not available for your role.",
        split_snapshot: "Split frozen with the Direccion VoBo.",
        parties: {
          colega: "Colleague",
          vendedora: "Seller",
          opcionadora: "Property provider",
          almikia: "Almikia",
        },
      },
      vobo: {
        title: "Direccion VoBo",
        status: {
          pendiente: "VoBo pending",
          solicitado: "VoBo requested",
          aprobado: "VoBo approved",
          observado: "VoBo flagged",
        },
        decided: "Decided by %{name} on %{date}",
        requested: "Requested on %{date}",
        note: "Note",
        ready: "Ready to request the VoBo",
        missing: "Something is missing: %{fields}",
        missing_fields: {
          shared: "whether it is shared with a colleague",
          colega: "the colleague",
          found_by: "who found the colleague",
          vendedora_clave: "the seller's clave",
          commission_total: "the total commission",
        },
        request: "Request VoBo",
        approve: "Approve",
        observe: "Flag",
        reopen: "Reopen",
        confirm: "Confirm",
        note_for: {
          observado: "What needs to be fixed?",
          reopen: "Why is the sale being reopened?",
        },
        done: {
          requested: "VoBo requested",
          aprobado: "VoBo approved",
          observado: "VoBo flagged",
          reopen: "Sale reopened",
        },
        later_phase_note:
          "Accounting takes the sale from here in a later phase.",
      },
      sell: {
        action: "Sell this option",
        title: "Sell this option",
        description:
          "Choose the buyer lead. The option %{address} will become reserved.",
        lead: "Buyer lead",
        choose: "Choose a lead",
        no_leads: "There are no leads available to sell this option.",
        confirm: "Create operation",
        created: "Brokerage operation created",
      },
    },
    colegas: {
      page_title: "Colleagues",
      manage_link: "Go to Colleagues",
      add_action: "New colleague",
      edit_action: "Edit",
      deactivate_action: "Deactivate",
      reactivate_action: "Reactivate",
      inactive_marker: "Inactive",
      search_placeholder: "Search by name, phone or agency",
      empty: "No colleagues registered yet.",
      empty_description:
        "External colleagues who refer leads to you are registered here.",
      no_match: "No colleague matches your search.",
      picker_placeholder: "Choose a colleague",
      create_action: "Create colleague",
      restricted: "Registered colleague",
      created_notice: "Colleague registered",
      updated_notice: "Colleague updated",
      deactivated_notice: "Colleague deactivated",
      reactivated_notice: "Colleague reactivated",
      confirm_deactivate_title: "Deactivate this colleague?",
      confirm_deactivate_body:
        "The colleague is no longer offered on new leads. Leads that already have them keep them.",
      confirm_reactivate_title: "Reactivate this colleague?",
      confirm_reactivate_body:
        "The colleague is available again for new leads.",
    },
    // Almikia Epic EG (TASK-044): "Gastos" screens.
    expenses: {
      new: "New expense",
      edit_title: "Edit expense",
      back_to_detail: "Back to the expense",
      back_to_list: "Back to Expenses",
      totals: {
        link: "Monthly totals",
        title: "Monthly totals",
        excludes_cancelled: "Cancelled expenses are not included",
        amount: "Amount (MXN)",
        iva: "VAT",
        count: "Expenses",
        total_amount: "Total of the month",
        total_iva: "VAT of the month",
        total_count: "Number of expenses",
        by_category: "By category",
        by_paid_by: "By who paid",
        empty: "There are no expenses to show totals for yet",
        error: "The totals could not be loaded. Please try again.",
      },
      reimbursement: {
        link: "To reimburse to the partner",
        title: "To reimburse to the partner",
        subtitle:
          "Active expenses paid by Pepe Díaz, the only partner who is reimbursed.",
        pending_total: "Total pending reimbursement",
        pending_section: "Pending",
        done_section: "Reimbursed",
        empty_pending: "No expenses are pending reimbursement",
        empty_done: "No expenses have been reimbursed yet",
        error: "The expenses could not be loaded. Please try again.",
        reimbursed_on: "Reimbursed on",
        mark: "Mark as reimbursed",
        unmark: "Undo reimbursement",
        mark_selected:
          "Mark as reimbursed (%{smart_count}) |||| Mark as reimbursed (%{smart_count})",
        unmark_selected: "Undo reimbursement (%{smart_count})",
        select_all: "Select all",
        select_row: "Select %{concept}",
        dialog_title:
          "Mark as reimbursed |||| Mark %{smart_count} expenses as reimbursed",
        dialog_description:
          "Enter the date it was reimbursed. It cannot be a future date.",
        date: "Reimbursement date",
        confirm: "Confirm reimbursement",
        marked:
          "Expense marked as reimbursed |||| Expenses marked as reimbursed",
        unmarked: "Reimbursement undone",
      },
      search: "Concept or supplier",
      total_label: "Total of this view (cancelled excluded)",
      active: "Active",
      cancelled: "Cancelled",
      invoiced_yes: "Invoiced",
      invoiced_no: "No invoice",
      pending_reimbursement: "Pending reimbursement",
      reimbursed: "Reimbursed on %{date}",
      choose_category: "Choose a category",
      no_project: "No project (general expense)",
      iva_preview: "IVA included (%{pct}%): %{amount}",
      created_notice: "Expense registered",
      updated_notice: "Expense updated",
      save_error: "The expense could not be saved. Try again.",
      filters: {
        month: "Month",
        category: "Category",
        paid_by: "Paid by",
        invoiced: "Invoiced",
        all: "All",
        yes: "Yes",
        no: "No",
      },
      fields: {
        date: "Date",
        concept: "Concept",
        category: "Category",
        supplier: "Supplier",
        amount: "Amount (MXN)",
        subtotal: "Subtotal",
        iva: "IVA",
        has_iva: "Includes IVA",
        invoiced: "Invoiced",
        invoiced_switch: "Was invoiced",
        cfdi_uuid: "CFDI UUID",
        cfdi_pdf: "CFDI PDF",
        cfdi_xml: "CFDI XML",
        paid_by: "Paid by",
        paid_by_other: "Name of who paid",
        payment_method: "Payment method",
        project: "Project / cost center",
        notes: "Notes",
        receipt: "Receipt",
        status: "Status",
      },
      paid_by_values: {
        sibaris: "Sibaris",
        pepe_diaz: "Pepe Díaz",
        otro: "Other",
      },
      payment_methods: {
        efectivo: "Cash",
        transferencia: "Bank transfer",
        tarjeta: "Card",
        otro: "Other",
      },
      files: {
        upload: "Upload file",
        replace: "Replace file",
        open: "Open",
        attached: "File attached",
        none: "No file",
        open_error: "The file could not be opened",
        error_invalid_type: "That file type is not accepted",
        error_too_large: "The file exceeds the 10 MB limit",
        error_upload: "The file could not be uploaded",
      },
      cancel: {
        action: "Cancel expense",
        title: "Cancel expense",
        description:
          "The expense stays in the list as Cancelled and no longer counts in the totals. This cannot be undone.",
        reason: "Reason for the cancellation",
        back: "Go back",
        confirm: "Confirm cancellation",
        done: "Expense cancelled",
        info: "Cancelled on %{date}. Reason: %{reason}",
      },
      categories: {
        link: "Expense categories",
        page_title: "Expense categories",
        name_field: "Category name",
        add_action: "Add category",
        edit_action: "Rename",
        archive_action: "Archive",
        reactivate_action: "Reactivate",
        archived_marker: "Archived",
        empty: "There are no categories yet",
        read_only: "Only Dirección can change the categories.",
        created_notice: "Category created",
        updated_notice: "Category updated",
        archived_notice: "Category archived",
        reactivated_notice: "Category reactivated",
        confirm_archive_title: "Archive category",
        confirm_archive_body:
          "It will no longer be offered for new expenses. Past expenses keep it.",
        confirm_reactivate_title: "Reactivate category",
        confirm_reactivate_body: "It will be offered again for new expenses.",
      },
    },
    profileOptions: {
      page_title: "Profile options",
      label_field: "Option name",
      add_action: "Add option",
      edit_action: "Edit",
      archive_action: "Archive",
      reactivate_action: "Reactivate",
      archived_marker: "Archived",
      empty: "This catalogue has no options yet.",
      created_notice: "Option created",
      updated_notice: "Option updated",
      archived_notice: "Option archived",
      reactivated_notice: "Option reactivated",
      confirm_archive_title: "Archive this option?",
      confirm_archive_body:
        "The option stops being offered for new selections. Leads that already hold it keep it, shown as archived.",
      confirm_reactivate_title: "Reactivate this option?",
      confirm_reactivate_body:
        "The option becomes available for new selections again.",
    },
    navigation: {
      label: "CRM navigation",
      more: "More",
    },
    profile: {
      add_secondary_email: "Add an email",
      advisor_code_taken: "This advisor code is already used by another user",
      advisor_code_reserved:
        "This advisor code is reserved and cannot be assigned",
      advisor_code_note:
        "Direccion or your Lead Manager can update your advisor code.",
      no_advisor_code: "You haven't added it yet",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
      invalid_rfc: "RFC must be 12 or 13 uppercase alphanumeric characters",
      invalid_fiscal_zip_code: "Fiscal zip code must be 5 digits",
      invalid_curp: "CURP must be 18 alphanumeric characters",
      curp_not_allowed_persona_moral:
        "CURP does not apply to a legal entity client",
      future_birthday: "Birthday cannot be in the future",
      invalid_children_count: "Number of children must be an integer >= 0",
      marital_regime_required:
        "The marital property regime is required when marital status is married",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
